async function copyTextToClipboard(buttonElement, text) {
  try {
    await navigator.clipboard.writeText(text);
    buttonElement.classList.add('copied');
    setTimeout(() => {
      buttonElement.classList.remove('copied');
    }, 5000);

  } catch (err) {
    console.error('Failed to copy text: ', err);
  }
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// Run non-critical initialization when browser is idle to reduce Total Blocking Time
function runWhenIdle(callback) {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(callback, { timeout: 2000 });
  } else {
    window.setTimeout(callback, 2000);
  }
}

function runAfterPageSettles(callback, delay) {
  if (typeof callback !== "function") return;

  var wait = typeof delay === "number" ? delay : 0;
  var start = function () {
    window.setTimeout(function () {
      runWhenIdle(callback);
    }, wait);
  };

  if (document.readyState === "complete") {
    start();
    return;
  }

  window.addEventListener("load", start, { once: true });
}

function initWhenVisible(element, callback, options) {
  if (!element || typeof callback !== "function") return null;

  var settings = options || {};
  if (
    settings.immediate ||
    typeof IntersectionObserver === "undefined" ||
    (window.Shopify && Shopify.designMode)
  ) {
    callback();
    return null;
  }

  try {
    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            try {
              observer.disconnect();
            } catch (e) {}
            callback();
            break;
          }
        }
      },
      {
        root: null,
        rootMargin: settings.rootMargin || "0px 0px 350px 0px",
        threshold: typeof settings.threshold === "number" ? settings.threshold : 0,
      }
    );

    observer.observe(element);
    return observer;
  } catch (e) {
    callback();
    return null;
  }
}

class AddressForm extends HTMLElement {
  constructor() {
    super();
    this.countrySelects = null;
    this.deleteButton = null;
    this._initialized = false;
  }

  connectedCallback() {
    // Prevent double-initialization if reconnected
    if (this._initialized) return;
    this._initialized = true;

    this.setupCountrySelectors();
    this.setupDeleteButton();
  }

  setupCountrySelectors() {
    if (!window.Shopify || !Shopify.CountryProvinceSelector) {
      return;
    }

    // All country selects inside this <address-form>
    this.countrySelects = this.querySelector('[data-address-country-selector]');
    if (!this.countrySelects) return;

      var formId = this.countrySelects.getAttribute('data-form-id');
      if (!formId) return;

      var countryId = 'AddressCountry_' + formId;
      var provinceId = 'AddressProvince_' + formId;
      var provinceContainerId = 'AddressProvinceContainer_' + formId;
      new Shopify.CountryProvinceSelector(countryId, provinceId, {
        hideElement: provinceContainerId
      });
  }

  setupDeleteButton() {
    // Only edit forms will have a related delete button
    var addressFormId = this.getAttribute('data-id');
    if (!addressFormId) {
      // e.g. "add new address" form – no delete
      return;
    }

    // delete-[data-id]
    var deleteButtonId = 'delete-' + addressFormId;
    var button = document.getElementById(deleteButtonId);
    if (!button) return;

    this.deleteButton = button;

    var self = this;
    button.addEventListener('click', function (event) {
      event.preventDefault();

      var message = button.getAttribute('data-confirm-message') || '';
      var targetUrl = button.getAttribute('data-target');

      if (!targetUrl) return;

      if (window.confirm(message)) {
        if (window.Shopify && typeof Shopify.postLink === 'function') {
          Shopify.postLink(targetUrl, {
            parameters: { _method: 'delete' }
          });
        } else {
          // Fallback if Shopify.postLink is not available
          window.location.href = targetUrl;
        }
      }
    });
  }
}

if ('customElements' in window && !customElements.get('address-form')) {
  customElements.define('address-form', AddressForm);
}

class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.button = null;
    this.scrollHandler = this.handleScroll.bind(this);
    this.clickHandler = this.scrollToTop.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('#backToTop');

    if (!this.button) return;

    window.addEventListener('scroll', this.scrollHandler);
    this.button.addEventListener('click', this.clickHandler);

    this.handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.scrollHandler);
    if (this.button) {
      this.button.removeEventListener('click', this.clickHandler);
    }
  }

  handleScroll() {
    var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    var viewportHeight = window.innerHeight;

    if (scrollPosition > viewportHeight) {
      this.button.classList.add('show');
    } else {
      this.button.classList.remove('show');
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

customElements.define('back-to-top', BackToTop);

class StoreHeadbar extends HTMLElement {
  constructor() {
    super();
    this.lastScrollY = window.scrollY;
    this.ticking = false;

    // 🔧 CONFIG — change values here only
    this.TOP_HIDE_OFFSET = 500; // px before hide starts
    this.SCROLL_DELTA = 5;      // ignore tiny scroll jitter
  }

  connectedCallback() {
    this.isSticky = this.dataset.sticky === 'true';
    this.hideOnScroll = this.dataset.hideOnScroll === 'true';
    this._setHeaderHeight();
    window.addEventListener('resize', this._onResize.bind(this));

    if (this.isSticky) {
      this.classList.add('is-sticky');
    }
    window.addEventListener('scroll', this._onScroll.bind(this), { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
    window.removeEventListener('scroll', this._onScroll);
  }

  _onResize() {
    this._setHeaderHeight();
  }

  _setHeaderHeight() {
    const height = this.offsetHeight || 0;
    document.body.style.setProperty('--header-height', `${height}px`);
    const announcementSection = document.querySelector('announcement-bar');
    const announcementHeight = announcementSection ? announcementSection.offsetHeight : 0;

    document.body.style.setProperty('--announcement-height', `${announcementHeight}px`);
    
  }

  _onScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this._handleScroll();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }
  _handleScroll() {
    const currentY = window.scrollY;
    
    if (currentY <= 60) {
        this.classList.remove('is-scrolled');
    }
    else{
        this.classList.add('is-scrolled');
    }
    if (this.isSticky && this.hideOnScroll) {
      // Always show header near top
      if (currentY <= this.TOP_HIDE_OFFSET) {
        this.classList.remove('is-hidden');
        this.classList.add('is-visible');
        this.lastScrollY = currentY;
        if(this.transparent){
          this.classList.remove('is-scrolled');
        }
        return;
      }

      // Ignore micro scroll
      if (Math.abs(currentY - this.lastScrollY) < this.SCROLL_DELTA) return;

      if (currentY > this.lastScrollY) {
        // ↓ scroll
        this.classList.add('is-hidden');
        this.classList.remove('is-visible');
      } else {
        // ↑ scroll
        this.classList.remove('is-hidden');
        this.classList.add('is-visible');
      }
    }

    this.lastScrollY = currentY;
  }
}

customElements.define('store-headbar', StoreHeadbar);

class HeaderDropdown extends HTMLElement {
  connectedCallback() {
    this.parentItem = this.parentElement;

    if (!(this.parentItem instanceof HTMLElement)) return;

    this.desktopMedia = window.matchMedia('(min-width: 1039px)');
    this.handlePositionUpdate = this.updatePosition.bind(this);
    this.handleViewportChange = this.resetPosition.bind(this);

    this.parentItem.addEventListener('mouseenter', this.handlePositionUpdate);
    this.parentItem.addEventListener('focusin', this.handlePositionUpdate);
    window.addEventListener('resize', this.handleViewportChange, { passive: true });
  }

  disconnectedCallback() {
    if (!(this.parentItem instanceof HTMLElement)) return;

    this.parentItem.removeEventListener('mouseenter', this.handlePositionUpdate);
    this.parentItem.removeEventListener('focusin', this.handlePositionUpdate);
    window.removeEventListener('resize', this.handleViewportChange);
  }

  resetPosition() {
    if (!(this.parentItem instanceof HTMLElement)) return;

    this.parentItem.classList.remove('dropdown--align-right', 'has-dropdown--open-left');

    if (this.desktopMedia.matches) {
      this.updatePosition();
    }
  }

  updatePosition() {
    if (!(this.parentItem instanceof HTMLElement) || !this.desktopMedia.matches) return;

    this.parentItem.classList.remove('dropdown--align-right', 'has-dropdown--open-left');

    const submenuWidth = this.getBoundingClientRect().width;

    if (!submenuWidth) return;

    const viewportPadding = 16;
    const parentRect = this.parentItem.getBoundingClientRect();
    const opensFromNestedItem = this.parentItem.classList.contains('has-dropdown');

    if (opensFromNestedItem) {
      const availableRight = window.innerWidth - parentRect.right - viewportPadding;
      const availableLeft = parentRect.left - viewportPadding;

      if (submenuWidth > availableRight && availableLeft > availableRight) {
        this.parentItem.classList.add('has-dropdown--open-left');
      }

      return;
    }

    const availableForLeftAlignedMenu = window.innerWidth - parentRect.left - viewportPadding;
    const availableForRightAlignedMenu = parentRect.right - viewportPadding;

    if (submenuWidth > availableForLeftAlignedMenu && availableForRightAlignedMenu >= submenuWidth) {
      this.parentItem.classList.add('dropdown--align-right');
    }
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown);
}
class MobileMenu extends HTMLElement {
  connectedCallback() {
    this.openers = document.querySelectorAll('[data-hamburger-mobile]');
    this.closeBtns = this.querySelectorAll('[data-drawer-close]');
    this.overlay = this.querySelector('[data-drawer-overlay]');
    this.lastTrigger = null;

    this._onDrawerClick = this._onDrawerClick.bind(this);
    this._onEscape = this._onEscape.bind(this);

    this._bindEvents();
  }

  _bindEvents() {
    var _this = this;

    this.openers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        _this.lastTrigger = btn;
        _this.open();
      });
    });

    this.addEventListener('click', this._onDrawerClick);
  }

  _onDrawerClick(e) {
    var closeBtn = e.target.closest('[data-drawer-close]');
    var overlay = e.target.closest('[data-drawer-overlay]');
    var openTrigger = e.target.closest('[data-submenu-open]');
    var backTrigger = e.target.closest('[data-submenu-back]');

    if (closeBtn || overlay) {
      e.preventDefault();
      this.close();
      return;
    }

    if (openTrigger) {
      e.preventDefault();
      this.openSubmenu(openTrigger);
      return;
    }

    if (backTrigger) {
      e.preventDefault();
      this.closeSubmenu(backTrigger);
    }
  }

  open() {
    this.setAttribute('aria-hidden', 'false');
    this.classList.add('is-active');

    document.body.classList.add('overflow-hide');
    document.addEventListener('keydown', this._onEscape);

    var focusTarget =
      this.querySelector('[data-drawer-close]') ||
      this.querySelector('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

    if (window.FocusTrap && focusTarget) {
      window.FocusTrap.trap(this, focusTarget, this.close.bind(this));
    } else if (focusTarget) {
      focusTarget.focus({ preventScroll: true });
    }
  }

  close() {
    this.setAttribute('aria-hidden', 'true');
    this.classList.remove('is-active');
    this._resetSubmenus();

    document.removeEventListener('keydown', this._onEscape);

    if (window.FocusTrap) {
      window.FocusTrap.release(this);
    }

    var openDialogs = document.querySelectorAll(
      'dialog.is-active, dialog.is-open, .dialog.is-active, .dialog.is-open, mobile-menu.is-active'
    );

    if (openDialogs.length === 0) {
      document.body.classList.remove('overflow-hide');
    }

    if (this.lastTrigger) {
      this.lastTrigger.focus();
      this.lastTrigger = null;
    }
  }

  _onEscape(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      this.close();
    }
  }

  openSubmenu(trigger) {
    var parent = trigger.closest('.drawer-item-parent');
    if (!parent) return;

    var submenu = parent.querySelector('.menu-drawer-submenu');
    if (!submenu) return;

    submenu.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');

    var firstFocusable = submenu.querySelector(
      'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (firstFocusable) {
      if (typeof firstFocusable.focus === 'function') {
        firstFocusable.focus({ preventScroll: true });
      }
    }
  }

  closeSubmenu(trigger) {
    var submenu = trigger.closest('.menu-drawer-submenu');
    if (!submenu) return;

    submenu.setAttribute('aria-hidden', 'true');

    var parent = submenu.closest('.drawer-item-parent');
    var opener = parent ? parent.querySelector('[data-submenu-open]') : null;

    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus({ preventScroll: true });
    }
  }

  _resetSubmenus() {
    this.querySelectorAll('[data-submenu-open]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    var submenus = this.querySelectorAll('.menu-drawer-submenu');

    submenus.forEach(function (menu) {
      menu.setAttribute('aria-hidden', 'true');
    });
  }
}

customElements.define('mobile-menu', MobileMenu);

class AsideMenu extends HTMLElement {
  connectedCallback() {
    this.openers = document.querySelectorAll('[data-hamburger-desktop]');
    if (!this.openers.length) return;

    this.isOpen = false;
    this.lastTrigger = null;

    this._onClick = this._onClick.bind(this);
    this._onDocumentMouseDown = this._onDocumentMouseDown.bind(this);
    this._onKeydown = this._onKeydown.bind(this);

    this.openers.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.lastTrigger = btn;
        this.toggle();
      });
    });

    this.addEventListener('click', this._onClick);
  }

  _onClick(e) {
    var trigger = e.target.closest('[data-aside-open]');
    if (!trigger) return;

    e.preventDefault();

    var panel = trigger.nextElementSibling;
    if (!panel) return;

    var isOpen = trigger.classList.contains('active');

    trigger.classList.toggle('active', !isOpen);
    trigger.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');

    panel.classList.toggle('is-active', !isOpen);
    panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');

    if (!isOpen) {
      var firstFocusable = panel.querySelector(
        'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );

      if (firstFocusable) firstFocusable.focus();
    } else {
      trigger.focus();
    }
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    if (this.isOpen) return;

    this.isOpen = true;
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('aside-open');

    document.addEventListener('mousedown', this._onDocumentMouseDown);
    document.addEventListener('keydown', this._onKeydown);

    var focusTarget =
      this.querySelector('[data-aside-close]') ||
      this.querySelector('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])') ||
      this.lastTrigger ||
      this.openers[0];

    this._trapAsideFocus(focusTarget);
  }

  close() {
    if (!this.isOpen) return;

    this.isOpen = false;
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('aside-open');

    document.removeEventListener('mousedown', this._onDocumentMouseDown);
    document.removeEventListener('keydown', this._onKeydown);

    this._releaseAsideFocus();

    var activeTriggers = this.querySelectorAll('[data-aside-open].active');
    activeTriggers.forEach(function (el) {
      el.classList.remove('active');
      el.setAttribute('aria-expanded', 'false');
    });

    var openPanels = this.querySelectorAll('.menu-aside-inner.is-active');
    openPanels.forEach(function (el) {
      el.classList.remove('is-active');
      el.setAttribute('aria-hidden', 'true');
    });

    if (this.lastTrigger) {
      this.lastTrigger.focus();
      this.lastTrigger = null;
    }
  }

  _onDocumentMouseDown(e) {
    if (!this.isOpen) return;

    var clickedOpener = Array.prototype.some.call(this.openers, function (btn) {
      return btn.contains(e.target);
    });

    if (!this.contains(e.target) && !clickedOpener) {
      this.close();
    }
  }

  _onKeydown(e) {
    if (!this.isOpen) return;

    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      this.close();
      return;
    }

    if (e.key !== 'Tab' && e.keyCode !== 9) return;

    this._handleTrapTab(e);
  }

  _getFocusableItems() {
    var selector =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    var items = [];

    Array.prototype.forEach.call(this.openers, function (btn) {
      if (btn.offsetParent !== null) {
        items.push(btn);
      }
    });

    Array.prototype.forEach.call(this.querySelectorAll(selector), function (el) {
      if (
        el.offsetParent !== null ||
        window.getComputedStyle(el).position === 'fixed'
      ) {
        items.push(el);
      }
    });

    return items;
  }

  _trapAsideFocus(initialFocus) {
    if (initialFocus && typeof initialFocus.focus === 'function') {
      initialFocus.focus();
    }
  }

  _releaseAsideFocus() {
    // no-op because this trap is handled manually
  }

  _handleTrapTab(e) {
    var focusables = this._getFocusableItems();

    if (!focusables.length) {
      e.preventDefault();
      return;
    }

    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var active = document.activeElement;

    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
      return;
    }

    if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  }
}

customElements.define('aside-menu', AsideMenu);


class OnDemandMedia extends HTMLElement {
  constructor() {
    super();
    this._loaded = false;
    this._io = null;
    this._onButtonClick = this._onButtonClick.bind(this);
    this._button = null;
    this._loadFrame = null;
    this._iframePlaying = false;
  }

  connectedCallback() {
    if (this.hasAttribute('data-dialog-media')) {
      console.log('return')
      return null;;
    }
    this.refresh();
  }

  disconnectedCallback() {
    this._cleanupObserver();
    this._detachButton();
    if (this._loadFrame) {
      cancelAnimationFrame(this._loadFrame);
      this._loadFrame = null;
    }
  }

  refresh(options) {
    var settings = options || {};
    var existingMedia = this._findLoadedMedia();
    var isButtonMode = this._isButtonMode();

    this._cleanupObserver();
    this._detachButton();

    this._loaded = !!existingMedia;
    if (existingMedia) {
      this._normalizeMediaAccessibility(this);
      if (isButtonMode) {
        this._attachButton();
        this._syncMediaState(existingMedia);
      } else {
        this._playMedia(existingMedia);
      }
      return existingMedia;
    }

    this._iframePlaying = false;

    if (isButtonMode) {
      this._attachButton();
      return null;
    }

    if (settings.immediate) {
      this._queueLoad();
      return null;
    }

    this._addObserver();
    return null;
  }

  // ---- Button support -------------------------------------------------------
  _attachButton() {
    // Preferred: developer can pass a selector scoped to the nearest section,
    // fallback to a common default .video-play-button in nearest .shopify-section
    var selector = this.getAttribute("data-button") || ".video-play-button";
    this.placeholerMediaSelector = '.placeholder-media';
    var section = this.closest(".shopify-section") || document;
    var btn = section.querySelector(selector);
    this.placeholder = section.querySelector(this.placeholerMediaSelector)

    if (!btn) return; // no-op if button not present
    this._button = btn;
    this._setButtonState(false);
    this._button.addEventListener("click", this._onButtonClick);
    // Optional keyboard activation for accessibility
    this._button.addEventListener("keydown", this._onButtonKeyDown);
  }

  _detachButton() {
    if (!this._button) return;
    this._button.removeEventListener("click", this._onButtonClick);
    this._button.removeEventListener("keydown", this._onButtonKeyDown);
    this._button = null;
  }

  _onButtonClick = () => {
    this.togglePlayback();
  };

  _onButtonKeyDown = (e) => {
    var code = e.code || e.key;
    if (
      code === "Enter" ||
      code === " " ||
      code === "Spacebar" ||
      code === "Space"
    ) {
      e.preventDefault();
      this.togglePlayback();
    }
  };

  _findLoadedMedia() {
    var children = this.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (!child || !child.tagName) continue;

      var tagName = child.tagName.toLowerCase();
      if (tagName === "template" || tagName === "noscript") continue;

      if (tagName === "video" || tagName === "iframe") return child;

      if (typeof child.querySelector === "function") {
        var nestedMedia = child.querySelector("video,iframe");
        if (nestedMedia) return nestedMedia;
      }
    }

    return null;
  }

  _isButtonMode() {
    var autoplayAttr = (this.getAttribute("data-autoplay") || "").toLowerCase();
    return (
      this.classList.contains("autoplay-false") || autoplayAttr === "false"
    );
  }

  _setButtonState(isPlaying) {
    if (!this._button) return;
    this._button.classList.toggle("is-playing", !!isPlaying);
    this._button.setAttribute("aria-pressed", isPlaying ? "true" : "false");
  }

  _syncMediaState(mediaEl) {
    this._setButtonState(this._isMediaPlaying(mediaEl));
  }

  _isMediaPlaying(mediaEl) {
    if (!mediaEl || !mediaEl.tagName) return false;

    var tagName = mediaEl.tagName.toLowerCase();
    if (tagName === "video") {
      return !mediaEl.paused && !mediaEl.ended;
    }

    if (tagName === "iframe") {
      return !!this._iframePlaying;
    }

    return false;
  }

  togglePlayback() {
    var mediaEl = this._findLoadedMedia();

    if (!mediaEl) {
      return this.loadContent();
    }

    if (this._isMediaPlaying(mediaEl)) {
      this._pauseMedia(mediaEl);
    } else {
      this._playMedia(mediaEl);
    }

    return mediaEl;
  }

  // ---- IntersectionObserver support ----------------------------------------
  _addObserver() {
    if (typeof IntersectionObserver === "undefined") {
      // Fallback: load immediately
      this.loadContent();
      return;
    }

    var rootMargin =
      this.getAttribute("data-root-margin") || "0px 0px 1000px 0px";
    var thresholdAttr = this.getAttribute("data-threshold");
    var threshold = thresholdAttr ? parseFloat(thresholdAttr) : 0;

    try {
      this._io = new IntersectionObserver(
        (entries) => {
          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            if (entry.isIntersecting) {
              this.loadContent();
              this._cleanupObserver();
              break;
            }
          }
        },
        {
          root: null,
          rootMargin: rootMargin,
          threshold: isNaN(threshold) ? 0 : threshold,
        }
      );
      this._io.observe(this);
    } catch (e) {
      // If IO construction fails for any reason, load immediately
      this.loadContent();
    }
  }

  _cleanupObserver() {
    if (this._io) {
      try {
        this._io.disconnect();
      } catch (e) {}
      this._io = null;
    }
  }

  _normalizeMediaAccessibility(root) {
    if (!root || typeof root.querySelectorAll !== "function") return;

    var previewImages = root.querySelectorAll("video img");
    for (var i = 0; i < previewImages.length; i++) {
      previewImages[i].setAttribute("alt", "");
      previewImages[i].setAttribute("aria-hidden", "true");
      previewImages[i].setAttribute("role", "presentation");
    }
  }

  // ---- Core: load from <template> / <noscript> and play video ---------------
  loadContent() {
    var existingMedia = this._findLoadedMedia();
    if (existingMedia) {
      this._loaded = true;
      this._normalizeMediaAccessibility(this);
      this._syncMediaState(existingMedia);
      return existingMedia;
    }

    this._loaded = false;

    // Prefer <template> content
    var tpl = this.querySelector("template");
    var injected = null;
    if(this.placeholder){
      this.placeholder.style.display = "none";
    }
    if (tpl && tpl.content && tpl.content.firstElementChild) {
      injected = tpl.content.firstElementChild.cloneNode(true);
      this.appendChild(injected);
    } else {
      // Fallback: try <noscript> (some themes include a mirrored <noscript>)
      var ns = this.querySelector("noscript");
      if (ns && ns.textContent) {
        // Create a container to parse noscript HTML
        var div = document.createElement("div");
        div.innerHTML = ns.textContent.trim();
        if (div.firstElementChild) {
          injected = div.firstElementChild;
          this.appendChild(injected);
        }
      }
    }

    // If nothing to inject, bail
    if (!injected) return null;

    this._loaded = true;
    this._cleanupObserver();
    this._normalizeMediaAccessibility(this);

    var mediaEl = this._findLoadedMedia() || injected;
    this._playMedia(mediaEl);

    if (!this._isButtonMode()) {
      this._detachButton();
    }

    return mediaEl;
  }

  _queueLoad() {
    if (this._loadFrame) {
      cancelAnimationFrame(this._loadFrame);
    }

    this._loadFrame = requestAnimationFrame(() => {
      this._loadFrame = null;
      if (!this._findLoadedMedia()) {
        this.loadContent();
      }
    });
  }

  _bindVideoState(videoEl) {
    if (!videoEl || videoEl.__onDemandMediaStateBound) return;

    videoEl.addEventListener("play", () => {
      this._setButtonState(this._isButtonMode());
    });
    videoEl.addEventListener("pause", () => {
      this._setButtonState(false);
    });
    videoEl.addEventListener("ended", () => {
      this._setButtonState(false);
    });

    videoEl.__onDemandMediaStateBound = true;
  }

  _postMessage(iframeEl, message) {
    if (!iframeEl || !iframeEl.contentWindow) return;

    try {
      iframeEl.contentWindow.postMessage(message, "*");
    } catch (e) {
      /* ignore */
    }
  }

  _playMedia(mediaEl) {
    if (!mediaEl || !mediaEl.tagName) return;

    var tagName = mediaEl.tagName.toLowerCase();
    if (tagName === "iframe") {
      if (mediaEl.src.indexOf("youtube.com") !== -1) {
        this._postMessage(
          mediaEl,
          '{"event":"command","func":"mute","args":""}'
        );
        this._postMessage(
          mediaEl,
          '{"event":"command","func":"playVideo","args":""}'
        );
      } else if (mediaEl.src.indexOf("player.vimeo.com") !== -1) {
        this._postMessage(mediaEl, '{"method":"setVolume","value":0}');
        this._postMessage(mediaEl, '{"method":"play"}');
      }

      this._iframePlaying = true;
      this._setButtonState(this._isButtonMode());
      return;
    }

    if (tagName !== "video") return;

    try {
      this._bindVideoState(mediaEl);
      mediaEl.muted = true;
      mediaEl.defaultMuted = true;
      mediaEl.setAttribute("muted", "muted");
      var p = mediaEl.play();
      if (p && typeof p.then === "function") {
        p.catch(function () {
          /* ignore */
        });
      }
    } catch (e) {
      /* ignore */
    }
  }

  _pauseMedia(mediaEl) {
    if (!mediaEl || !mediaEl.tagName) return;

    var tagName = mediaEl.tagName.toLowerCase();
    if (tagName === "iframe") {
      if (mediaEl.src.indexOf("youtube.com") !== -1) {
        this._postMessage(
          mediaEl,
          '{"event":"command","func":"pauseVideo","args":""}'
        );
      } else if (mediaEl.src.indexOf("player.vimeo.com") !== -1) {
        this._postMessage(mediaEl, '{"method":"pause"}');
      }

      this._iframePlaying = false;
      this._setButtonState(false);
      return;
    }

    if (tagName !== "video") return;

    try {
      mediaEl.pause();
      this._setButtonState(false);
    } catch (e) {
      /* ignore */
    }
  }
}

customElements.define("on-demand-media", OnDemandMedia);

function refreshOnDemandMedia(root) {
  if (!root) return;

  var items = [];
  if (root.matches && root.matches("on-demand-media")) {
    items.push(root);
  }

  if (root.querySelectorAll) {
    var scopedItems = root.querySelectorAll("on-demand-media");
    for (var i = 0; i < scopedItems.length; i++) {
      items.push(scopedItems[i]);
    }
  }

  for (var j = 0; j < items.length; j++) {
    var item = items[j];
    if (!item || typeof item.refresh !== "function") continue;

    var autoplayAttr = (item.getAttribute("data-autoplay") || "").toLowerCase();
    var isAutoplay =
      !item.classList.contains("autoplay-false") && autoplayAttr !== "false";

    var eagerAttr = (item.getAttribute("data-eager-load") || "").toLowerCase();
    var loadImmediately = eagerAttr === "true" || eagerAttr === "immediate";

    // Only eager-load autoplay media when it is already in or near the viewport.
    // This avoids blank visible media while still keeping deeper sections deferred.
    if (
      !loadImmediately &&
      isAutoplay &&
      typeof item.getBoundingClientRect === "function"
    ) {
      var rect = item.getBoundingClientRect();
      var viewportHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        0;

      if (rect.top < viewportHeight + 200 && rect.bottom > -200) {
        loadImmediately = true;
      }
    }

    item.refresh({ immediate: loadImmediately });
  }
}

document.addEventListener("shopify:section:load", function (event) {
  refreshOnDemandMedia(event.target);
});

class DialogBox extends HTMLElement {
  constructor() {
    super();

    this._onOverlayClick = this._onOverlayClick.bind(this);
    this._onCloseClick = this._onCloseClick.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
    this._onAttrChange = this._onAttrChange.bind(this);

    this._mo = null;
    this._prevFocused = null;

    // drag state
    this._isDragging = false;
    this._closingByDrag = false;
    this._targetEl = null;
  }

  connectedCallback() {
    this.overlay = this.querySelector('.dialog-overlay');
    this.closeBtn = this.querySelector('.dialog-close');
    if (this.closeBtn && !this.closeBtn.getAttribute('aria-label')) {
      this.closeBtn.setAttribute('aria-label', 'Close dialog');
    }
    this.openBtns = document.querySelectorAll(
      `[data-dialog-open][data-id="${this.id}"]`
    );  
    if (this.openBtns.length > 0) {
      Array.from(this.openBtns).forEach((openBtn)=>{
        openBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this._targetEl = openBtn;
          this.open();
        });
      })
    }

    if (this.overlay && !this.closest('age-verification-popup')) {
      this.overlay.addEventListener('click', this._onOverlayClick);
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this._onCloseClick);
    }

    // observe open / close for focus trap
    this._mo = new MutationObserver(this._onAttrChange);
    this._mo.observe(this, {
      attributes: true,
      attributeFilter: ['class'],
    });

    if (this.classList.contains('is-open')) {
      // Dialog is already open, activate trap
      if (window.FocusTrap) {
        const focusables = this._getFocusable();
        if (focusables.length > 0) {
          let initialFocusEl = this.querySelector('[data-dialog-initial-focus]');
          if (!initialFocusEl) {
            initialFocusEl = focusables.find(el => !el.hasAttribute('data-skip-initial-focus'));
          }
          if (!initialFocusEl) {
            initialFocusEl = focusables[0];
          }
          window.FocusTrap.trap(this, initialFocusEl);
        }
      }
    }

    // mobile drag
    this._initMobileDrag();
  }

  disconnectedCallback() {
    this.overlay?.removeEventListener('click', this._onOverlayClick);
    this.closeBtn?.removeEventListener('click', this._onCloseClick);
    // Remove from focus trap if still in stack
    if (window.FocusTrap) {
      window.FocusTrap.release(this);
    }
    this._mo?.disconnect();
  }

  /* ---------- PUBLIC API ---------- */
  open() {
    this.classList.add('is-open', 'is-active');
    document.body.classList.add('overflow-hide');
    
    // Use the new stack-based FocusTrap system
    if (window.FocusTrap) {
      const focusables = this._getFocusable();
      let initialFocusEl = null;
      
      if (focusables.length > 0) {
        // 1️⃣ Try explicit initial focus
        initialFocusEl = this.querySelector('[data-dialog-initial-focus]');
        
        // 2️⃣ Otherwise: first focusable NOT marked to skip
        if (!initialFocusEl) {
          initialFocusEl = focusables.find(el => !el.hasAttribute('data-skip-initial-focus'));
        }
        
        // 3️⃣ Absolute fallback
        if (!initialFocusEl) {
          initialFocusEl = focusables[0];
        }
      }
      const medias = this.querySelectorAll('on-demand-media');
      Array.from(medias).forEach(function(media){
        if (media && typeof media.loadContent === 'function') {
          media.loadContent();
        }
      })
      // Pass onEscape callback so Escape key closes the dialog
      var self = this;
      window.FocusTrap.trap(this, initialFocusEl, function() {
        self.close();
      });
    }
    
    this.dispatchEvent(new CustomEvent('dialog:open'));
  }

  close() {
    this.classList.remove('is-open', 'is-active');
    
    // Release focus trap for this dialog
    if (window.FocusTrap) {
      window.FocusTrap.release(this);
    }
    if(this._targetEl){
      this._targetEl.focus();
      this._targetEl = null;
    }
    var openDialogs = document.querySelectorAll('dialog.is-active,dialog.is-open,.dialog.is-active,.dialog.is-open');
    if (openDialogs.length === 0) {
      document.body.classList.remove('overflow-hide');
    }

    this.dispatchEvent(new CustomEvent('dialog:close'));

    const removeDelay = parseInt(
      this.getAttribute('data-remove-delay') || '300',
      10
    );

    setTimeout(() => {
      if (this.hasAttribute('data-temporary')) {
        this.remove();
      }
    }, removeDelay);
  }

  /* ---------- INTERNAL ---------- */
  _onOverlayClick() {
    if (this._isDragging) return;
    this.close();
  }

  _onCloseClick() {
    this.close();
  }

  _onAttrChange(mutations) {
    for (const m of mutations) {
      if (m.attributeName !== 'class') continue;

      if (this.classList.contains('is-open')) {
        // Dialog opened - focus trap is handled in open()
        // But if this is called due to external class changes, ensure trap is active
        if (window.FocusTrap) {
          const focusables = this._getFocusable();
          if (focusables.length > 0) {
            let initialFocusEl = this.querySelector('[data-dialog-initial-focus]');
            if (!initialFocusEl) {
              initialFocusEl = focusables.find(el => !el.hasAttribute('data-skip-initial-focus'));
            }
            if (!initialFocusEl) {
              initialFocusEl = focusables[0];
            }
            window.FocusTrap.trap(this, initialFocusEl);
          }
        }
      } else {
        // Dialog closed
        if (window.FocusTrap) {
          window.FocusTrap.release(this);
        }
      }
    }
  }

  _onKeydown(e) {
    // Focus trapping is now handled by window.FocusTrap
    // This method is kept for backward compatibility but not called
  }

  _activateTrap() {
    // Focus trapping is now handled by window.FocusTrap
    // This method is kept for backward compatibility but not called
  }

  _deactivateTrap() {
    // Focus trapping is now handled by window.FocusTrap
    // This method is kept for backward compatibility but not called
  }

  _getFocusable() {
    const root = this.querySelector(".dialog-card") || this;

    const selector = [
      'a[href]',
      'area[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
      '[contenteditable="true"]'
    ].join(',');

    const nodes = Array.prototype.slice.call(root.querySelectorAll(selector));

    return nodes.filter(el => {
      return (
        el.offsetParent !== null ||
        getComputedStyle(el).position === 'fixed'
      );
    });
  }

  /* ---------- MOBILE DRAG ---------- */
  _initMobileDrag() {
    const handle = this.querySelector('.mobiledrag, .mobile-drag');
    const drawer = this.querySelector('.dialog-inner'); // The sliding part
    if (!handle || !drawer) return;

    let startY = 0;
    let deltaY = 0;
    let maxDeltaY = 0;
    let drawerHeight = 0;
    let startTime = 0;

    // 1. Touch Start (Scoped to handle)
    handle.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      
      this._isDragging = true;
      startY = e.touches[0].clientY;
      deltaY = 0;
      maxDeltaY = 0;
      drawerHeight = drawer.offsetHeight;
      startTime = Date.now();

      drawer.style.transition = 'none';
      e.stopPropagation(); 
      
      // Attach GLOBAL listeners so dragging never breaks
      document.addEventListener('touchmove', onTouchMove, { passive: false });
      document.addEventListener('touchend', onTouchEnd);
    }, { passive: true });

    // 2. Global Move (Defined inside so it can access variables)
    const onTouchMove = (e) => {
      if (!this._isDragging) return;

      const currentY = e.touches[0].clientY;
      deltaY = Math.max(0, currentY - startY);
      maxDeltaY = Math.max(maxDeltaY, deltaY);

      // Using the 0.95 damping from your working version
      const displayDelta = Math.min(deltaY, drawerHeight) * 0.95;
      drawer.style.transform = `translateY(${displayDelta}px)`;
    };

    // 3. Global End
    const onTouchEnd = () => {
      if (!this._isDragging) return;
      this._isDragging = false;

      const elapsed = Date.now() - startTime;
      const velocity = maxDeltaY / Math.max(elapsed, 1);
      const finalRatio = deltaY / drawerHeight;

      // Use the Working Version's Thresholds
      const shouldClose = finalRatio >= 0.25 || (maxDeltaY >= 80 && velocity >= 0.5);

      // Match the Working Version's Bezier
      drawer.style.transition = 'transform 0.4s cubic-bezier(0.2, 1, 0.3, 1)';

      if (shouldClose) {
        drawer.style.transform = `translateY(100%)`;
        
        // Match the Working Version's sync logic
        setTimeout(() => {
          if (typeof this.close === 'function') this.close();
          
          // Clean up the styles after the drawer is actually gone
          setTimeout(() => {
            drawer.style.transition = '';
            drawer.style.transform = '';
          }, 200);
        }, 300);
      } else {
        // Snap back up
        drawer.style.transform = 'translateY(0)';
      }

      // Clean up global listeners to save memory
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
    };
  }

}

customElements.define('dialog-box', DialogBox);

class PredictiveSearchDrawer extends HTMLElement {
  connectedCallback() {
    if (!window.themeSettings?.predictiveEnabled) return;

    this.dialog = this.querySelector('#searchDialog');
    this.input = this.querySelector('#predictiveSearchInput');

    this.searchType = 'product';
    if(window.themeSettings?.predictiveSearchSettings?.showCollections){
      this.searchType = this.searchType + ',collection';
    }
    if(window.themeSettings?.predictiveSearchSettings?.showQueries){
      this.searchType = this.searchType + ',query';
    }
    if(window.themeSettings?.predictiveSearchSettings?.showPages){
      this.searchType = this.searchType + ',page';
    }
    if(window.themeSettings?.predictiveSearchSettings?.showArticles){
      this.searchType = this.searchType + ',article';
    }
    this.loader = this.querySelector('.predictive-search-loader');
    this.resultsWrapper = this.querySelector('[data-search-results]');
    this.recommendations = this.querySelector('.predictive-search-categories');
    this.collectionsReco = this.querySelector('.predictive-search-collections');

    this.abortController = null;
    this.debounceTimer = null;

    this._bindEvents();
    // this._watchDialogOpen();
    this._bindTabs();
    this._reset();

    // react to dialog close
    this.dialog?.addEventListener('dialog:close', () => {
      this._reset();
    });
    this.dialog?.addEventListener('dialog:open', () => {
      setTimeout(() => {
        this.input?.focus();
      }, 1000);
    });
  }
  _watchDialogOpen() {
    if (!this.dialog) return;

    const observer = new MutationObserver(() => {
      if (this.dialog.classList.contains('is-active')) {
        setTimeout(() => {
          this.input?.focus();
        }, 1000);
      }
    });

    observer.observe(this.dialog, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  _bindEvents() {
    if (this.input) {
      this.input.addEventListener('input', () => {
        const q = this.input.value.trim();
        clearTimeout(this.debounceTimer);

        this.debounceTimer = setTimeout(() => {
          if (!q) {
            this._reset();
            return;
          }
          this._search(q);
        }, 250);
      });
    }

    this.addEventListener('click', function (e) {
      var clearBtn = e.target.closest('search-clear');
      if (!clearBtn) return;

      e.preventDefault();

      if (this.input) {
        this.input.value = '';
        this.input.focus();
      }

      this._abortActive();
      this._reset(); 
    });
  }

  _search(query) {
    this._abortActive();

    this._show(this.loader);
    this._hide(this.recommendations);
    this._hide(this.collectionsReco);

    this.abortController = new AbortController();
    const url =
      window.routespredictive_search_url +
      '?q=' +
      encodeURIComponent(query) +
      '&section_id=predictive-search'+ '&resources[limit_scope]=each&resources[type]='+this.searchType;

    fetch(url, { signal: this.abortController.signal })
      .then((res) => res.text())
      .then((html) => {
        this.resultsWrapper.innerHTML = html;
        this._show(this.resultsWrapper);
        this._activateFirstTab();
      })
      .catch((err) => {
        if (err.name !== 'AbortError') this._reset();
      })
      .finally(() => {
        this._hide(this.loader);
      });
  }

  _abortActive() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
  }

  _reset() {
    this._abortActive();

    if (this.input) this.input.value = '';

    this._hide(this.resultsWrapper);
    this._hide(this.loader);

    this._show(this.recommendations);
    this._show(this.collectionsReco);
  }

  /* ---------- TABS ---------- */
  _bindTabs() {
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('.side-tab-btns');
      if (!btn) return;
      this._activateTab(btn);
    });
  }

  _activateTab(activeBtn) {
    const panel = this.querySelector('.search-tab-panel');
    if (!panel) return;

    const buttons = panel.querySelectorAll('.side-tab-btns');
    const contents = panel.querySelectorAll(
      '.side-tab-panel-content > div'
    );

    const index = Array.prototype.indexOf.call(buttons, activeBtn);
    if (index < 0) return;

    buttons.forEach((btn) => {
      btn.classList.remove('is-selected');
      btn.setAttribute('aria-selected', 'false');
    });

    contents.forEach((c) => c.classList.add('display-none'));

    activeBtn.classList.add('is-selected');
    activeBtn.setAttribute('aria-selected', 'true');

    contents[index]?.classList.remove('display-none');
  }

  _activateFirstTab() {
    const first = this.querySelector('.side-tab-btns');
    if (first) this._activateTab(first);
  }

  _show(el) {
    el?.classList.remove('display-none');
  }

  _hide(el) {
    el?.classList.add('display-none');
  }
}

customElements.define(
  'predictive-search-drawer',
  PredictiveSearchDrawer
);

class SearchForm extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this._bindEvents();
  }

  _bindEvents() {

    this.addEventListener('click', function (e) {
      var clearBtn = e.target.closest('search-clear');
      if (!clearBtn) return;
      e.preventDefault();

      if (this.input) {
        this.input.value = '';
        this.input.focus();
      } 
    });
  }

}

customElements.define(
  'search-form',
  SearchForm
);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.headings = this.querySelectorAll("[data-tab-selector]");
    this.contents = this.querySelectorAll("[data-tab-content]");
  }

  connectedCallback() {
    Array.from(this.headings).forEach((heading) => {
      heading.addEventListener("click", (e) => {
        if (heading.classList.contains("active")) return;
        e.preventDefault();
        this.switchTab(heading);
      });
    });
  }
  switchTab(heading) {
    const targetTab = heading.dataset.tab;
    Array.from(this.headings).forEach((heading) => {
      heading.classList.remove("active");
    });
    Array.from(this.contents).forEach((content) => {
      content.classList.remove("active");
      if (content.id === targetTab) {
        content.classList.add("active");
      }
    });
    heading.classList.add("active");
  }
}

// Define the custom element
customElements.define("localization-form", LocalizationForm);

class SlideshowMainComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.activeIndex = 0;
    this.resizeObserver = null;
    this._vendorLoadRequested = false;
    this._interactionInitAttached = false;
    this._boundShopifyBlockSelect = this._onShopifyBlockSelect.bind(this);
    this._boundShopifyBlockDeselect = this._onShopifyBlockDeselect.bind(this);
    this._boundInteractionInit = this._handleInteractionInit.bind(this);
  }

  connectedCallback() {
    if (this.getAttribute("data-init-mode") === "interaction") {
      this._scheduleInitSlider();
    } else {
      // Initialize once DOM is ready
      this.initSlider();
    }

    window.addEventListener(
      "shopify:block:select",
      this._boundShopifyBlockSelect
    );
    window.addEventListener( 
      "shopify:block:deselect",
      this._boundShopifyBlockDeselect
    );
  }

  disconnectedCallback() {
    // Cleanup on removal
    this.destroySlider();
    this._teardownInteractionInit();
    window.removeEventListener(
      "shopify:block:select",
      this._boundShopifyBlockSelect
    );
    window.removeEventListener(
      "shopify:block:deselect",
      this._boundShopifyBlockDeselect
    );
  }

  _scheduleInitSlider() {
    if (this.slider || this._interactionInitAttached) return;

    if (window.Shopify && Shopify.designMode) {
      this.initSlider();
      return;
    }

    const target = this.closest(".slider-banner") || this;
    ["pointerenter", "mouseenter", "focusin", "touchstart", "pointerdown", "click"].forEach(
      (eventName) => {
        target.addEventListener(eventName, this._boundInteractionInit, {
          passive: eventName !== "focusin" && eventName !== "click"
        });
      }
    );

    this._interactionInitAttached = true;
  }

  _teardownInteractionInit() {
    if (!this._interactionInitAttached) return;

    const target = this.closest(".slider-banner") || this;
    ["pointerenter", "mouseenter", "focusin", "touchstart", "pointerdown", "click"].forEach(
      (eventName) => {
        target.removeEventListener(eventName, this._boundInteractionInit);
      }
    );

    this._interactionInitAttached = false;
  }

  _handleInteractionInit() {
    this._teardownInteractionInit();
    this.initSlider();
  }

  initSlider() {
    if (typeof Swiper === "undefined") {
      return;
    }

    this._vendorLoadRequested = false;

    // Destroy existing instance if reinitializing
    if (this.slider) {
      this.slider.destroy(true, true);
      this.slider = null;
    }

    // Get settings from <script type="application/json" class="slider-settings">
    const configScript = this.querySelector(
      'script.slider-settings[type="application/json"]'
    );
    let settings = {};
    if (configScript) {
      try {
        settings = JSON.parse(configScript.textContent.trim());
      } catch (e) {
        console.warn("Invalid JSON in slider-settings:", e);
      }
    }

    // Initialize Swiper
    try {
      this.slider = new Swiper(
        this.querySelector("[data-slideshow-selector]"),
        settings
      );
    } catch (err) {
      console.error("Failed to initialize Swiper:", err);
      return;
    }

    // Bind events
    this.slider.on("init", () => this.handleSlideChange());
    this.slider.on("slideChange", () => {
      this.handleSlideChange();
    });

    // Observe for resize updates
    if (typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(() => {
        try {
          this.slider.update();
        } catch (e) {}
      });
      this.resizeObserver.observe(this);
    }
  }

  handleSlideChange() {
    if (!this.slider) return;
    const realIndex =
      this.slider.realIndex != null
        ? this.slider.realIndex
        : this.slider.activeIndex;

    // Pause videos from all slides
    const allVideos = this.querySelectorAll("video");
    allVideos.forEach((v) => {
      try {
        if (!v.paused) v.pause();
      } catch (e) {}
    });

    // Play video in current active slide
    const activeSlide = this.querySelector(
      `.swiper-slide[data-swiper-slide-index="${realIndex}"]:not(.swiper-slide-duplicate)`
    );
    if (activeSlide) {
      const videos = activeSlide.querySelectorAll("video");
      videos.forEach((v) => {
        try {
          v.play().catch(() => {});
        } catch (e) {}
      });
    }

    // Update navigation content
    this.updateNavigation(realIndex);
  }

  updateNavigation(activeIndex) {
    const navItems = this.querySelectorAll(
      ".slider-banner-navigation [data-slide-content]"
    );
    navItems.forEach((item) => {
      const idx = parseInt(item.getAttribute("data-slide-content"), 10);
      if (idx === activeIndex) {
        item.classList.add("active");
        item.removeAttribute("aria-hidden");
      } else {
        item.classList.remove("active");
        item.setAttribute("aria-hidden", "true");
      }
    });
  }
  _onShopifyBlockSelect(evt) {
    if (!this.slider) return;

    // Detect block ID
    let blockId = evt?.detail?.blockId || evt?.detail?.id || null;
    if (!blockId) return;

    // Stop autoplay if running
    if (this.slider.autoplay && this.slider.autoplay.running) {
      this.slider.autoplay.stop();
      this._autoplayWasRunning = true;
    } else {
      this._autoplayWasRunning = false;
    }

    // Find corresponding slide for this block
    const targetNav = this.querySelector(`#block-content-${blockId}`);
    if (targetNav) {
      const targetIndex = parseInt(
        targetNav.getAttribute("data-slide-content"),
        10
      );
      if (!isNaN(targetIndex)) {
        if (typeof this.slider.slideToLoop === "function") {
          this.slider.slideToLoop(targetIndex);
        } else {
          this.slider.slideTo(targetIndex);
        }
      }
    }
  }

  _onShopifyBlockDeselect() {
    // Resume autoplay if it was running before block select
    if (this.slider && this.slider.autoplay && this._autoplayWasRunning) {
      this.slider.autoplay.start();
      this._autoplayWasRunning = false;
    }
  }
  destroySlider() {
    try {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    } catch (e) {}
  }
}

// Define the custom element
customElements.define("slideshow-main-component", SlideshowMainComponent);

class CollectionCarousel extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.activeIndex = 0;
    this.resizeObserver = null;
    this._vendorLoadRequested = false;

    this.disableOnMobile = this.getAttribute("data-disable-mobile") === "true";
    this.mobileBreakpoint = window.matchMedia("(max-width: 767.98px)");
    this._visibilityObserver = null;
    this._boundResize = this._updateTextSlideWidth.bind(this);
    this._boundShopifyBlockSelect = this._onShopifyBlockSelect.bind(this);
    this._boundShopifyBlockDeselect = this._onShopifyBlockDeselect.bind(this);
    this._handleBreakpointChange = this._handleBreakpointChange.bind(this);
  }

  connectedCallback() {
    if (this.disableOnMobile) {
      this._handleBreakpointChange();
      this.mobileBreakpoint.addListener(this._handleBreakpointChange);
    } else {
      this._scheduleInitSlider();
    }
    window.addEventListener("resize", this._boundResize);
    window.addEventListener(
      "shopify:block:select",
      this._boundShopifyBlockSelect
    );
    window.addEventListener(
      "shopify:block:deselect",
      this._boundShopifyBlockDeselect
    );
  }

  disconnectedCallback() {
    this.destroySlider();
    if (this._visibilityObserver) {
      try {
        this._visibilityObserver.disconnect();
      } catch (e) {}
      this._visibilityObserver = null;
    }
    if (this.mobileBreakpoint) {
      this.mobileBreakpoint.removeListener(this._handleBreakpointChange);
    }
    window.removeEventListener("resize", this._boundResize);
    window.removeEventListener(
      "shopify:block:select",
      this._boundShopifyBlockSelect
    );
    window.removeEventListener(
      "shopify:block:deselect",
      this._boundShopifyBlockDeselect
    );
  }
  _scheduleInitSlider() {
    if (this.slider || this._visibilityObserver) return;

    this._visibilityObserver = initWhenVisible(this, () => {
      this._visibilityObserver = null;
      this.initSlider();
    });
  }
  _handleBreakpointChange() {
    if (!this.disableOnMobile) return;

    if (this.mobileBreakpoint.matches) {
      // mobile
      if (this.slider) {
        this.destroySlider();
      }
    } else {
      // desktop
      if (!this.slider) {
        this._scheduleInitSlider();
      }
    }
  }
  initSlider() {
    if (typeof Swiper === "undefined") {
      return;
    }

    this._vendorLoadRequested = false;

    // Destroy existing instance if reinitializing
    if (this.slider) {
      this.slider.destroy(true, true);
      this.slider = null;
    }

    // Get settings from <script type="application/json" class="slider-settings">
    const configScript = this.querySelector(
      'script.slider-settings[type="application/json"]'
    );
    let settings = {};
    if (configScript) {
      try {
        settings = JSON.parse(configScript.textContent.trim());
      } catch (e) {
        console.warn("Invalid JSON in slider-settings:", e);
      }
    }

    // Initialize Swiper
    try {
      this.slider = new Swiper(this, settings);
    } catch (err) {
      console.error("Failed to initialize Swiper:", err);
      return;
    }

    this.slider.on("init", () => this._updateTextSlideWidth());
    // Observe for resize updates
    if (typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(() => {
        try {
          this.slider.update();
          this._updateTextSlideWidth();
        } catch (e) {}
      });
      this.resizeObserver.observe(this);
    }
  }
  _updateTextSlideWidth() {
    try {
      var textBlock = this.querySelector(".collection-carousel-slide-text");
      if (!textBlock) return;

      var vw = window.innerWidth || document.documentElement.clientWidth;
      if (vw < 767) {
        textBlock.style.display = "none";
        textBlock.style.width = "";
        textBlock.style.left = "";
        textBlock.style.position = "";
        return;
      } else {
        textBlock.style.display = "";
      }

      var wrapper = this.querySelector(".collection-carousel-wrapper");
      if (!wrapper) return;

      // find original slides (non-duplicate)
      var originals;
      try {
        originals = wrapper.querySelectorAll(
          ":scope > .swiper-slide:not(.swiper-slide-duplicate)"
        );
      } catch (err) {
        var tmpAll = wrapper.querySelectorAll(".swiper-slide");
        originals = [];
        for (var ii = 0; ii < tmpAll.length; ii++) {
          if (!tmpAll[ii].classList.contains("swiper-slide-duplicate"))
            originals.push(tmpAll[ii]);
        }
      }
      if (!originals || originals.length === 0) {
        originals = wrapper.querySelectorAll(".swiper-slide");
        if (!originals || originals.length === 0) return;
      }

      // measure one slide width (use the first original as measured)
      var measureSlide = originals[0];
      var measureRect = measureSlide.getBoundingClientRect();
      var slideWidth = Math.round(measureRect.width);
      textBlock.style.maxWidth = slideWidth + "px";

      // If show_on_first class present — always place above first visible (index 0)
      if (
        textBlock.classList &&
        textBlock.classList.contains("show_on_first")
      ) {
        var firstVisible = originals[0];
        var containerRectFallback = this.getBoundingClientRect();
        var fvRect = firstVisible.getBoundingClientRect();
        textBlock.style.position = "absolute";
        textBlock.style.left =
          Math.round(fvRect.left - containerRectFallback.left) + "px";
        return;
      }

      // Determine slidesPerView (effective)
      var spv = null;
      if (
        this.slider &&
        this.slider.params &&
        this.slider.params.slidesPerView != null
      ) {
        spv = this.slider.params.slidesPerView;
      }
      var spvNum = parseFloat(spv);
      if (isNaN(spvNum) || spvNum < 1) spvNum = 1;

      // Find first visible slide among originals by checking bounding rect relative to container
      var containerRect = this.getBoundingClientRect();
      var firstVisibleIndex = 0;
      var found = false;
      for (var i = 0; i < originals.length; i++) {
        var sRect = originals[i].getBoundingClientRect();
        // consider visible if its left is >= container left - 1 (tiny tolerance)
        if (sRect.right > containerRect.left + 1) {
          // has at least some visible portion
          firstVisibleIndex = i;
          found = true;
          break;
        }
      }
      if (!found) firstVisibleIndex = 0;

      // target visible slide index (zero-based)
      var targetVisiblePos = Math.max(0, Math.floor(spvNum) - 1);
      var targetIndex = firstVisibleIndex + targetVisiblePos;
      if (targetIndex >= originals.length) targetIndex = originals.length - 1;

      var targetSlide = originals[targetIndex] || originals[0];
      var targetRect = targetSlide.getBoundingClientRect();
      var leftOffset = Math.round(targetRect.left - containerRect.left);

      // apply absolute positioning relative to carousel root
      textBlock.style.position = "absolute";
      textBlock.style.left = leftOffset + "px";
    } catch (e) {
      // silent
    }
  }
  _onShopifyBlockSelect(evt) {
    if (!this.slider) return;

    // Detect block ID
    let blockId = evt?.detail?.blockId || evt?.detail?.id || null;
    if (!blockId) return;

    // Stop autoplay if running
    if (this.slider.autoplay && this.slider.autoplay.running) {
      this.slider.autoplay.stop();
      this._autoplayWasRunning = true;
    } else {
      this._autoplayWasRunning = false;
    }

    // Find corresponding slide for this block
    const targetNav = this.querySelector(`#block-collection-${blockId}`);
    if (targetNav) {
      const targetIndex = parseInt(
        targetNav.getAttribute("data-swiper-slide-index"),
        10
      );
      if (!isNaN(targetIndex)) {
        if (typeof this.slider.slideToLoop === "function") {
          this.slider.slideToLoop(targetIndex);
        } else {
          this.slider.slideTo(targetIndex);
        }
      }
    }
  }

  _onShopifyBlockDeselect() {
    // Resume autoplay if it was running before block select
    if (this.slider && this.slider.autoplay && this._autoplayWasRunning) {
      this.slider.autoplay.start();
      this._autoplayWasRunning = false;
    }
  }

  destroySlider() {
    try {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    } catch (e) {}
  }
}

// Define the custom element
customElements.define("collection-carousel", CollectionCarousel);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.activeIndex = 0;
    this.resizeObserver = null;
    this.mobileBreakpoint = window.matchMedia("(max-width: 767.98px)");
    this._visibilityObserver = null;
    this._interactionInitAttached = false;
    this._vendorLoadRequested = false;
    this._boundShopifyBlockSelect = this._onShopifyBlockSelect.bind(this);
    this._boundShopifyBlockDeselect = this._onShopifyBlockDeselect.bind(this);
    this._handleBreakpointChange = this._handleBreakpointChange.bind(this);
    this._boundInteractionInit = this._handleInteractionInit.bind(this);
    this._linkedOtherSlider = null;
    this._linkedSelfHandler = null;
    this._linkedOtherHandler = null;
    this._linkedSyncUnlockTimer = null;
  }

  connectedCallback() {
    this.disableOnMobile = this.getAttribute("data-disable-mobile") === "true";

    if (this.disableOnMobile) {
      this.mobileBreakpoint = window.matchMedia("(max-width: 767.98px)");
      this._handleBreakpointChange = this._handleBreakpointChange.bind(this);

      this._handleBreakpointChange();
      this.mobileBreakpoint.addListener(this._handleBreakpointChange);
    } else {
      this._scheduleInitSlider();
    }

    window.addEventListener(
      "shopify:block:select",
      this._boundShopifyBlockSelect
    );

    window.addEventListener(
      "shopify:block:deselect",
      this._boundShopifyBlockDeselect
    );
  }

  disconnectedCallback() {
    this.destroySlider();
    if (this._visibilityObserver) {
      try {
        this._visibilityObserver.disconnect();
      } catch (e) {}
      this._visibilityObserver = null;
    }
    this._teardownInteractionInit();

    if (this.mobileBreakpoint) {
      this.mobileBreakpoint.removeListener(this._handleBreakpointChange);
    }

    window.removeEventListener(
      "shopify:block:select",
      this._boundShopifyBlockSelect
    );
    window.removeEventListener(
      "shopify:block:deselect",
      this._boundShopifyBlockDeselect
    );
  }

  _scheduleInitSlider() {
    if (this.slider || this._visibilityObserver || this._interactionInitAttached) return;

    if (this._shouldInitOnInteraction()) {
      this._scheduleInteractionInit();
      return;
    }

    this._visibilityObserver = initWhenVisible(this, () => {
      this._visibilityObserver = null;
      this.initSlider();
    });
  }
 
  _shouldInitOnInteraction() {
    return this.getAttribute("data-init-mode") === "interaction";
  }

  _scheduleInteractionInit() {
    if (this.slider || this._interactionInitAttached) return;

    if (window.Shopify && Shopify.designMode) {
      this.initSlider();
      return;
    }

    // In some cases (e.g. card-product hover-to-reveal secondary slider), the component
    // may initially be hidden, so track hover/click on a container as fallback.
    this._interactionInitTarget = this.closest(".card-product-img") || this;

    ["pointerenter", "mouseenter", "focusin", "touchstart", "pointerdown", "click"].forEach(
      (eventName) => {
        this._interactionInitTarget.addEventListener(eventName, this._boundInteractionInit, {
          passive: eventName !== "focusin" && eventName !== "click"
        });
      }
    );

    this._interactionInitAttached = true;
  }

  _teardownInteractionInit() {
    if (!this._interactionInitAttached) return;

    var target = this._interactionInitTarget || this;
    ["pointerenter", "mouseenter", "focusin", "touchstart", "pointerdown", "click"].forEach(
      (eventName) => {
        target.removeEventListener(eventName, this._boundInteractionInit);
      }
    );

    this._interactionInitAttached = false;
    this._interactionInitTarget = null;
  }

  _handleInteractionInit() {
    this._teardownInteractionInit();
    this.initSlider();
  }

  _handleBreakpointChange() {
    if (!this.disableOnMobile) return;

    if (this.mobileBreakpoint.matches) {
      if (this.slider) {
        this.destroySlider();
      }
    } else {
      if (!this.slider) {
        this._scheduleInitSlider();
      }
    }
  }

  initSlider() {
  if (typeof Swiper === "undefined") {
    return;
  }

  this._vendorLoadRequested = false;
  this._teardownInteractionInit();

  // Destroy existing instance if reinitializing
  if (this.slider) {
    try { this.slider.destroy(true, true); } catch (e) {}
    this.slider = null;
  }

  // Get settings from <script type="application/json" class="slider-settings">
  const configScript = this.querySelector('script.slider-settings[type="application/json"]:first-child');
  var settings = {};
  if (configScript) {
    try {
      settings = JSON.parse(configScript.textContent.trim());
    } catch (e) {
      console.warn("Invalid JSON in slider-settings:", e,this);
    }
  }

  // Defensive: try to resolve navigation selectors to DOM elements (if strings)
  try {
    if (settings && settings.navigation) {
      if (settings.navigation.nextEl && typeof settings.navigation.nextEl === "string") {
        try { var nextNode = document.querySelector(settings.navigation.nextEl); if (nextNode) settings.navigation.nextEl = nextNode; } catch (e) {}
      }
      if (settings.navigation.prevEl && typeof settings.navigation.prevEl === "string") {
        try { var prevNode = document.querySelector(settings.navigation.prevEl); if (prevNode) settings.navigation.prevEl = prevNode; } catch (e) {}
      }
    }
  } catch (e) {}

  // Initialize Swiper
  try {
    this.slider = new Swiper(this, settings);
  } catch (err) {
    console.error("Failed to initialize Swiper:", err);
    return;
  }

  this._setupLinkedSliderSync(settings);

  // Observe for resize updates
  if (typeof ResizeObserver !== "undefined") {
    this.resizeObserver = new ResizeObserver(() => {
      try {
        this.slider.update();
      } catch (e) {}
    });
    this.resizeObserver.observe(this);
  }
  }

  _getSwiperRealIndex(swiper) {
    if (!swiper) return 0;

    return typeof swiper.realIndex === "number"
      ? swiper.realIndex
      : swiper.activeIndex || 0;
  }

  _getSwiperSlideCount(swiper) {
    if (!swiper || !swiper.el) return 0;

    var originalSlides = swiper.el.querySelectorAll(
      ".swiper-slide:not(.swiper-slide-duplicate)"
    );

    if (originalSlides && originalSlides.length) {
      return originalSlides.length;
    }

    return swiper.slides ? swiper.slides.length : 0;
  }

  _getSwiperDirection(swiper) {
    if (!swiper) return null;

    if (swiper.swipeDirection === "next" || swiper.swipeDirection === "prev") {
      return swiper.swipeDirection;
    }

    if (
      typeof swiper.activeIndex === "number" &&
      typeof swiper.previousIndex === "number" &&
      swiper.activeIndex !== swiper.previousIndex
    ) {
      return swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
    }

    return null;
  }

  _slideSwiperToRealIndex(swiper, index, speed) {
    if (!swiper || typeof index !== "number" || isNaN(index)) return;
    if (this._getSwiperRealIndex(swiper) === index) return;

    if (typeof swiper.slideToLoop === "function") {
      swiper.slideToLoop(index, speed);
      return;
    }

    swiper.slideTo(index, speed);
  }

  _syncLinkedSwiper(sourceSlider, targetSlider) {
    if (!sourceSlider || !targetSlider) return;

    var targetIndex = this._getSwiperRealIndex(sourceSlider);
    var currentIndex = this._getSwiperRealIndex(targetSlider);

    if (currentIndex === targetIndex) return;

    var direction = this._getSwiperDirection(sourceSlider);
    var slideCount = this._getSwiperSlideCount(targetSlider);
    var speed = sourceSlider.params && sourceSlider.params.speed;

    if (slideCount > 1 && targetSlider.params && targetSlider.params.loop) {
      var nextIndex = (currentIndex + 1) % slideCount;
      var prevIndex = (currentIndex - 1 + slideCount) % slideCount;

      if (direction === "next" && targetIndex === nextIndex) {
        if (typeof targetSlider.slideNext === "function") {
          targetSlider.slideNext(speed);
          return;
        }
      }

      if (direction === "prev" && targetIndex === prevIndex) {
        if (typeof targetSlider.slidePrev === "function") {
          targetSlider.slidePrev(speed);
          return;
        }
      }
    }

    this._slideSwiperToRealIndex(targetSlider, targetIndex, speed);
  }

  _teardownLinkedSliderSync() {
    if (this._linkedSyncUnlockTimer) {
      clearTimeout(this._linkedSyncUnlockTimer);
      this._linkedSyncUnlockTimer = null;
    }

    if (
      this.slider &&
      this._linkedSelfHandler &&
      typeof this.slider.off === "function"
    ) {
      this.slider.off("slideChange", this._linkedSelfHandler);
    }

    if (
      this._linkedOtherSlider &&
      this._linkedOtherHandler &&
      typeof this._linkedOtherSlider.off === "function"
    ) {
      this._linkedOtherSlider.off("slideChange", this._linkedOtherHandler);
    }

    this._linkedOtherSlider = null;
    this._linkedSelfHandler = null;
    this._linkedOtherHandler = null;
  }

  _setupLinkedSliderSync(settings) {
    this._teardownLinkedSliderSync();

    try {
      var self = this;
      var linkSelector =
        this.getAttribute("data-linked-to") ||
        (settings && (settings.linkedTo || settings.linkWith)) ||
        null;

      if (!linkSelector) return;

      if (typeof linkSelector !== "string") {
        try {
          linkSelector = String(linkSelector);
        } catch (e) {}
      }

      (function attachToLinked(tries) {
        tries = tries || 0;

        if (!self.slider) return;

        var otherEl = null;
        try {
          otherEl = document.querySelector(linkSelector);
        } catch (e) {
          otherEl = null;
        }

        if (!otherEl) {
          if (tries < 30) {
            setTimeout(function () {
              attachToLinked(tries + 1);
            }, 100);
          }
          return;
        }

        var otherSliderInstance = otherEl.slider;
        if (!otherSliderInstance) {
          if (tries < 30) {
            setTimeout(function () {
              attachToLinked(tries + 1);
            }, 100);
          }
          return;
        }

        var syncing = false;

        function releaseSyncLock() {
          if (self._linkedSyncUnlockTimer) {
            clearTimeout(self._linkedSyncUnlockTimer);
          }

          self._linkedSyncUnlockTimer = setTimeout(function () {
            syncing = false;
          }, 0);
        }

        function syncTo(sourceSlider, targetSlider) {
          if (!sourceSlider || !targetSlider || syncing) return;

          var targetIndex = self._getSwiperRealIndex(sourceSlider);
          if (self._getSwiperRealIndex(targetSlider) === targetIndex) return;

          syncing = true;
          self._syncLinkedSwiper(sourceSlider, targetSlider);
          releaseSyncLock();
        }

        self._linkedOtherSlider = otherSliderInstance;
        self._linkedSelfHandler = function () {
          syncTo(self.slider, otherSliderInstance);
        };
        self._linkedOtherHandler = function () {
          syncTo(otherSliderInstance, self.slider);
        };

        if (typeof self.slider.on === "function") {
          self.slider.on("slideChange", self._linkedSelfHandler);
        }

        if (typeof otherSliderInstance.on === "function") {
          otherSliderInstance.on("slideChange", self._linkedOtherHandler);
        }

        syncTo(self.slider, otherSliderInstance);
      })(0);
    } catch (e) {}
  }

  destroySlider() {
    try {
      this._teardownLinkedSliderSync();
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    } catch (e) {}
  }
  _onShopifyBlockSelect(evt) {
    if (!this.slider) return;

    // Detect block ID
    let blockId = evt?.detail?.blockId || evt?.detail?.id || null;
    if (!blockId) return;

    // Stop autoplay if running
    if (this.slider.autoplay && this.slider.autoplay.running) {
      this.slider.autoplay.stop();
      this._autoplayWasRunning = true;
    } else {
      this._autoplayWasRunning = false;
    }

    // Find corresponding slide for this block
    const targetNav = this.querySelector(`#swiper-slide-${blockId},#shopify-block-${blockId}`);
    if (targetNav) {
      const targetIndex = parseInt(
        targetNav.getAttribute("data-swiper-slide-index"),
        10
      );
      if (!isNaN(targetIndex)) {
        if (typeof this.slider.slideToLoop === "function") {
          this.slider.slideToLoop(targetIndex);
        } else {
          this.slider.slideTo(targetIndex);
        }
      }
    }
  }

  _onShopifyBlockDeselect() {
    // Resume autoplay if it was running before block select
    if (this.slider && this.slider.autoplay && this._autoplayWasRunning) {
      this.slider.autoplay.start();
      this._autoplayWasRunning = false;
    }
  }
}

customElements.define("slider-component", SliderComponent);

// <compare-slide> — before/after drag for your provided markup
// Works with:
// - handle button:  <button class="compare-slide-button" data-compare-drag>
// - track: the whole <compare-slide> element
// - uses CSS var --percentage (0–100) you can consume in CSS to clip the "after" layer
// - pointer/mouse/touch drag, click-to-jump, keyboard (← →) on handle
// - cleans up listeners on disconnect

class CompareSlide extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.handle = this.querySelector('[data-compare-drag]');
    this.track  = this; // drag track is the entire compare-slide

    // State
    this.dragging = false;

    // Bindings
    this._onPointerDown = this._onPointerDown.bind(this);
    this._onPointerMove = this._onPointerMove.bind(this);
    this._onPointerUp   = this._onPointerUp.bind(this);
    this._onClickTrack  = this._onClickTrack.bind(this);
    this._onKey         = this._onKey.bind(this);

    // Optional: initial percent (fallback 50)
    this._initial = parseFloat(this.getAttribute('data-initial') || '50');
  }

  connectedCallback() {
    if (!this.handle) return;

    // Init position
    if (!this.style.getPropertyValue('--percentage')) {
      this._setPercent(this._initial);
    }

    // Pointer events (best)
    if (window.PointerEvent) {
      this.handle.addEventListener('pointerdown', this._onPointerDown);
      window.addEventListener('pointermove', this._onPointerMove);
      window.addEventListener('pointerup', this._onPointerUp);
    } else {
      // Mouse/touch fallback
      this.handle.addEventListener('mousedown', this._onPointerDown);
      window.addEventListener('mousemove', this._onPointerMove);
      window.addEventListener('mouseup', this._onPointerUp);

      this.handle.addEventListener('touchstart', this._onPointerDown, { passive: true });
      window.addEventListener('touchmove', this._onPointerMove, { passive: true });
      window.addEventListener('touchend', this._onPointerUp, { passive: true });
    }

    // Click to jump anywhere on track (except when clicking the handle)
    this.addEventListener('click', this._onClickTrack);

    // Keyboard control on handle
    this.handle.addEventListener('keydown', this._onKey);
  }

  disconnectedCallback() {
    if (window.PointerEvent) {
      this.handle && this.handle.removeEventListener('pointerdown', this._onPointerDown);
      window.removeEventListener('pointermove', this._onPointerMove);
      window.removeEventListener('pointerup', this._onPointerUp);
    } else {
      this.handle && this.handle.removeEventListener('mousedown', this._onPointerDown);
      window.removeEventListener('mousemove', this._onPointerMove);
      window.removeEventListener('mouseup', this._onPointerUp);

      this.handle && this.handle.removeEventListener('touchstart', this._onPointerDown);
      window.removeEventListener('touchmove', this._onPointerMove);
      window.removeEventListener('touchend', this._onPointerUp);
    }

    this.removeEventListener('click', this._onClickTrack);
    this.handle && this.handle.removeEventListener('keydown', this._onKey);
  }

  // --- Handlers
  _onPointerDown(e) {
    this.dragging = true;
    // capture pointer for smooth drag
    if (e.type === 'pointerdown' && this.handle.setPointerCapture) {
      try { this.handle.setPointerCapture(e.pointerId); } catch (_) {}
    }
    // Prevent text selection during drag
    document.body.style.userSelect = 'none';
  }

  _onPointerMove(e) {
    if (!this.dragging) return;

    const rect = this.track.getBoundingClientRect();
    let clientX;
    if (e.touches && e.touches[0]) clientX = e.touches[0].clientX;
    else clientX = e.clientX;

    const x = clientX - rect.left; // px from left within track
    this._updateFromX(x);
  }

  _onPointerUp(e) {
    if (!this.dragging) return;
    this.dragging = false;
    if (e && e.type === 'pointerup' && this.handle.releasePointerCapture) {
      try { this.handle.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    document.body.style.userSelect = '';
  }

  _onClickTrack(e) {
    // ignore clicks that originate on the handle itself
    if (e.target === this.handle || this.handle.contains(e.target)) return;

    const rect = this.track.getBoundingClientRect();
    const x = e.clientX - rect.left;
    this._updateFromX(x);
  }

  _onKey(e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    e.preventDefault();

    const current = parseFloat(this.style.getPropertyValue('--percentage')) || 50;
    const step = 1;
    const next = this._clampPercent(current + (e.key === 'ArrowLeft' ? -step : step));
    this._setPercent(next);
  }

  // --- Core math
  _updateFromX(xPx) {
    const w = this.clientWidth || this.track.clientWidth;
    if (!w) return;

    // Soft clamps to keep handle away from extreme edges (match your previous logic)
    const edge = 30; // px
    const clamped = Math.min(Math.max(xPx, edge), Math.max(edge, w - edge));
    const pct = (clamped / w) * 100;
    this._setPercent(pct);
  }

  _setPercent(p) {
    const pct = this._clampPercent(p);
    this.style.setProperty('--percentage', pct + '%');
  }

  _clampPercent(p) {
    if (p < 0) return 0;
    if (p > 100) return 100;
    return p;
  }
}

customElements.define('compare-slide', CompareSlide);

// <countdown-counter>
// Usage:
// <countdown-counter class="counter" data-end="2025-12-31T23:59:59Z"></countdown-counter>
// - Reads target end datetime from data-end (ISO 8601; supports timezone like ...Z).
// - Updates the 4 .counter-number spans in order: Days, Hours, Minutes, Seconds.
// - When countdown reaches 0, it hides the whole <countdown-counter>.
//
// Notes:
// - Hours/Minutes/Seconds are zero-padded to 2 digits. Days is not padded.
// - Cleans up its interval when removed from the DOM.

class CountdownCounter extends HTMLElement {
  constructor() {
    super();
    this._timer = null;
    this._end = null;
    this._numbers = null; // NodeList of .counter-number
  }

  connectedCallback() {
    const endAttr = this.getAttribute('data-end');
    if (!endAttr) return;

    const end = new Date(endAttr);
    if (isNaN(end.getTime())) {
      console.warn('countdown-counter: invalid data-end:', endAttr);
      return;
    }
    this._end = end;

    // cache number elements in expected order: Days, Hours, Minutes, Seconds
    this._numbers = this.querySelectorAll('.counter-number');
    if (!this._numbers || this._numbers.length < 4) {
      console.warn('countdown-counter: expected 4 ".counter-number" elements (Days, Hours, Minutes, Seconds).');
      return;
    }

    // initial paint and start ticking
    this._tick();
    this._timer = setInterval(() => this._tick(), 1000);
  }

  disconnectedCallback() {
    this._clear();
  }

  _clear() {
    if (this._timer) {
      clearInterval(this._timer);
      this._timer = null;
    }
  }

  _tick() {
    const now = new Date();
    let diff = this._end - now;

    if (diff <= 0) {
      // Time’s up: set all to 0 and hide
      this._setNumbers(0, 0, 0, 0);
      this._clear();
      this.style.display = 'none';
      return;
    }

    const dayMs = 24 * 60 * 60 * 1000;
    const hourMs = 60 * 60 * 1000;
    const minMs = 60 * 1000;
    const secMs = 1000;

    const days = Math.floor(diff / dayMs); diff -= days * dayMs;
    const hours = Math.floor(diff / hourMs); diff -= hours * hourMs;
    const mins = Math.floor(diff / minMs); diff -= mins * minMs;
    const secs = Math.floor(diff / secMs);

    this._setNumbers(days, hours, mins, secs);
  }

  _setNumbers(d, h, m, s) {
    const pad2 = (n) => (n < 10 ? '0' + n : String(n));
    // Expect order: 0=Days, 1=Hours, 2=Minutes, 3=Seconds
    this._numbers[0].textContent = String(d);
    this._numbers[1].textContent = pad2(h);
    this._numbers[2].textContent = pad2(m);
    this._numbers[3].textContent = pad2(s);
  }
}

customElements.define('countdown-counter', CountdownCounter);


class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.headings = this.querySelectorAll("[data-tab-selector]");
    this.contents = this.querySelectorAll("[data-tab-content]");
    this.navs = this.querySelectorAll("[data-nav-content]");
    this._boundShopifyBlockSelect = this._onShopifyBlockSelect.bind(this);
  }

  connectedCallback() {
    Array.from(this.headings).forEach((heading) => {
      heading.addEventListener("click", (e) => {
        if (heading.parentElement.classList.contains("is-active")) return;
        e.preventDefault();
        this.switchTab(heading);
      });
    });

    window.addEventListener(
      "shopify:block:select",
      this._boundShopifyBlockSelect
    );
  }
  switchTab(heading) {
    const targetTab = 'tab-content-'+heading.dataset.tab;
    const targetNav = 'tab-nav-'+heading.dataset.tab;
    Array.from(this.headings).forEach((heading) => {
      const isActive = heading.dataset.tab === targetTab.replace('tab-content-', '');
      heading.parentElement.classList.toggle("is-active", isActive);
      heading.setAttribute("aria-selected", isActive ? "true" : "false");
    });
    Array.from(this.contents).forEach((content) => {
      content.classList.add("tabs-hidden");
      content.setAttribute("aria-hidden", "true");
      content.setAttribute("hidden", "");
      if (content.id === targetTab) {
        content.classList.remove("tabs-hidden");
        content.setAttribute("aria-hidden", "false");
        content.removeAttribute("hidden");
      }
    });
    Array.from(this.navs).forEach((nav) => {
      nav.classList.add("tabs-hidden");
      if (nav.id === targetNav) {
        nav.classList.remove("tabs-hidden");
      }
    });
  } 
   _onShopifyBlockSelect(evt) {

    // Detect block ID
    let blockId = evt?.detail?.blockId || evt?.detail?.id || null;
    if (!blockId) return;


    // Find corresponding slide for this block
    const targetTab = this.querySelector(`[data-tab="${blockId}"]`);
    if (targetTab) {
      if (targetTab.parentElement.classList.contains("is-active")) return;
        this.switchTab(targetTab);
    }
  }
  disconnectedCallback() {

    window.removeEventListener(
      "shopify:block:select",
      this._boundShopifyBlockSelect
    );
  }
}

// Define the custom element
customElements.define("collection-tabs", CollectionTabs);

class SiteMarquee extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector("[data-marquee-track]");
    if (!this.track) return;

    // Store original content once
    this._baseHTML = this.track.innerHTML.trim();

    // bind so we can debounce
    this._fill = this._fill.bind(this);

    // Fill once on load
    this._fill();

    // Debounced resize listener (prevents page freeze)
    this._resizeHandler = this._debounce(() => {
      this._fill();
    }, 150);

    window.addEventListener("resize", this._resizeHandler);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._resizeHandler);
  }

  _fill() {
    // Reset content
    this.track.innerHTML = this._baseHTML;

    const parentWidth = this.parentElement.offsetWidth;
    const requiredWidth = parentWidth * 2;

    let currentWidth = this.track.scrollWidth;

    // Duplicate until ≥ 200%
    while (currentWidth < requiredWidth) {
      this.track.innerHTML += this._baseHTML;
      currentWidth = this.track.scrollWidth;

      // Safety break
      if (this.track.innerHTML.length > 30000) break;
    }

    // lock height if needed
    this.style.height = this.scrollHeight + "px";
    this.track.classList.add("active");
  }

  // Debounce function to avoid heavy loops on resize
  _debounce(fn, delay) {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }
}

customElements.define("site-marquee", SiteMarquee);


/* =========================
   ShoppableVideos custom element
   ========================= */

class ShoppableVideos extends HTMLElement {
  constructor() {
    super();
    this._io = null;
    this._observed = [];
    this._onClick = this._onClick.bind(this);
    this._observerThreshold = 0.25;
    this._patchedDialogClose = false;
  }

  connectedCallback() {
    // initialize observer and events scoped to this section
    this._initObserver();
    this._scanExistingVideos();
    this._bindPopupSliders();
    document.addEventListener('click', this._onClick, true);

    // patch DialogBox.close once per page (keeps DialogBox intact)
    if (!this._patchedDialogClose && typeof DialogBox !== 'undefined' && DialogBox.prototype && DialogBox.prototype.close) {
      this._patchDialogClose();
      this._patchedDialogClose = true;
    }
  }

  disconnectedCallback() {
    this._cleanupObserver();
    document.removeEventListener('click', this._onClick, true);
  }

  /* ---------- IntersectionObserver ---------- */
  _initObserver() {
    var self = this;
    if (this._io) return;
    if (typeof IntersectionObserver === 'undefined') return;

    try {
      this._io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          var vid = entry.target;
          if (!entry.isIntersecting) {
            try {
              if (vid && vid.tagName && vid.tagName.toLowerCase() === 'video' && !vid.muted) {
                vid.muted = true;
                self._syncMuteButtons(vid);
              }
            } catch (e) {}
          }
        }
      }, { threshold: this._observerThreshold });
    } catch (e) {
      this._io = null;
    }
  }

  _cleanupObserver() {
    if (!this._io) return;
    try { this._io.disconnect(); } catch (e) {}
    this._io = null;
    this._observed = [];
  }

  observeVideo(video) {
    if (!video) return;
    if (!this._io) this._initObserver();
    if (!this._io) return;
    if (this._observed.indexOf(video) === -1) {
      this._observed.push(video);
      try { this._io.observe(video); } catch (e) {}
    }
  }

  /* ---------- Ensure on-demand-media injects video ---------- */
  _ensureInjected(onDemandEl) {
    if (!onDemandEl) return null;

    var existing = onDemandEl.querySelector('video');
    if (existing) {
      this.observeVideo(existing);
      this._syncMuteButtons(existing);
      return existing;
    }

    try {
      if (typeof onDemandEl.loadContent === 'function') {
        onDemandEl.loadContent();
      }
    } catch (e) {}

    var injected = onDemandEl.querySelector('video');
    if (injected) {
      try { injected.muted = true; } catch (e) {}
      this.observeVideo(injected);
      this._syncMuteButtons(injected);
      this._checkPlayStatus(injected);
      return injected;
    }
    return null;
  }

  /* ---------- Click handling (scoped) ---------- */
  _onClick(e) {
    try {
      var muteBtn = e.target.closest && e.target.closest('[data-mute-unmute-button]');
      if (muteBtn && this.contains(muteBtn)) {
        this._handleMuteClick(muteBtn);
        return;
      }

      var playBtn = e.target.closest && e.target.closest('[data-play-pause-button]');
      if (playBtn && this.contains(playBtn)) {
        this._handlePlayClick(playBtn);
        return;
      }

      var dialogTrigger = e.target.closest && (e.target.closest('[data-dialog-button]') || e.target.closest('[data-dailog-button]'));
      if (dialogTrigger && this.contains(dialogTrigger)) {
        this._openDialogFromTrigger(dialogTrigger);
        return;
      }
    } catch (e) {}
  }

  _handleMuteClick(btn) {
    if (!btn) return;
    var wrapper = btn.closest('.shoppable-card, .video-inner-wrapper, .shoppable-thumb-item');
    if (!wrapper) return;

    var od = wrapper.querySelector('on-demand-media');
    var v = null;
    if (od) v = this._ensureInjected(od);
    if (!v) v = wrapper.querySelector('video');
    if (!v) return;

    try {
      if (v.muted) {
        // unmute this -> mute everyone else
        this._muteAllExcept(v);
        v.muted = false;
        this._syncMuteButtons(v);
      } else {
        v.muted = true;
        this._syncMuteButtons(v);
      }
    } catch (e) {}
  }
  _checkPlayStatus(video){
    if (!video) return;
    var wrapper = video.closest('.shoppable-card, .video-inner-wrapper, .shoppable-thumb-item');
    if (!wrapper) return;
    var btn = wrapper.querySelector('[data-play-pause-button]');
    if (!btn) return;
    try {
      if (video.paused) {
        btn.classList.remove('is-playing');
        btn.setAttribute('aria-label', 'Play video');
        btn.setAttribute('aria-pressed', 'false');
      } else {
        btn.classList.add('is-playing');
        btn.setAttribute('aria-label', 'Pause video');
        btn.setAttribute('aria-pressed', 'true');
      }
    } catch (e) {}

  }
  _handlePlayClick(btn) {
    if (!btn) return;
    var wrapper = btn.closest('.shoppable-card, .video-inner-wrapper, .shoppable-thumb-item');
    if (!wrapper) return;

    var od = wrapper.querySelector('on-demand-media');
    var v = null;
    if (od) v = this._ensureInjected(od);
    if (!v) v = wrapper.querySelector('video');
    if (!v) return;

    try {
      if (v.paused) {
        v.play().catch(function () {});
      } else {
        v.pause();
      }
      this._checkPlayStatus(v);
    } catch (e) {}
  }

  /* ---------- Mute helpers ---------- */
  _muteAllExcept(exceptVideo) {
    var all = document.querySelectorAll('video');
    for (var i = 0; i < all.length; i++) {
      try {
        var vv = all[i];
        if (exceptVideo && vv === exceptVideo) continue;
        if (!vv.muted) {
          vv.muted = true;
          this._syncMuteButtons(vv);
        }
      } catch (e) {}
    }
  }

  _syncMuteButtons(video) {
    if (!video) return;
    var wrappers = this.querySelectorAll('.shoppable-card, .video-inner-wrapper, .shoppable-thumb-item');
    for (var i = 0; i < wrappers.length; i++) {
      var w = wrappers[i];
      if (w.contains(video)) {
        var btns = w.querySelectorAll('[data-mute-unmute-button]');
        for (var b = 0; b < btns.length; b++) {
          try {
            if (video.muted) {
              btns[b].classList.add('is-muted');
              btns[b].setAttribute('aria-pressed', 'true');
              btns[b].setAttribute('aria-label', 'Unmute video');
            } else {
              btns[b].classList.remove('is-muted');
              btns[b].setAttribute('aria-pressed', 'false');
              btns[b].setAttribute('aria-label', 'Mute video');
            }
          } catch (e) {}
        }
      }
    }
  }

  /* ---------- Dialog open / content activation ---------- */
  _openDialogFromTrigger(trigger) {
  if (!trigger) return;
  var dialogId = trigger.getAttribute('data-dialog') || trigger.getAttribute('data-dailog');
  if (!dialogId) return;
  var dialogEl = document.getElementById(dialogId);
  if (!dialogEl) return;

  // Invalidate any previous pending async work (stale confirmMark calls)
  this._dialogOpenToken = (this._dialogOpenToken || 0) + 1;
  var myToken = this._dialogOpenToken;

  // clear any leftover timer from a previous call
  if (this._dialogConfirmTimer) {
    clearTimeout(this._dialogConfirmTimer);
    this._dialogConfirmTimer = null;
  }

  dialogEl.classList.add('is-open');
  document.body.classList.add('overflow-hide');

  var slide = trigger.closest('.swiper-slide, .shoppable-card');
  if (!slide) return;
  var blockId = slide.id || '';
  if (blockId.indexOf('swiper-slide-') === 0) blockId = blockId.replace('swiper-slide-', '');
  else if (blockId.indexOf('shopify-block-') === 0) blockId = blockId.replace('shopify-block-', '');

  var contentId = 'dialog-content-' + blockId;
  var altContentId = 'dailog-content-' + blockId;
  var contentEl = document.getElementById(contentId) || document.getElementById(altContentId);
  if (!contentEl) return;

  // Activate immediately through the shared function
  this._activateContent(contentEl, dialogEl);

  try {
    var popupSliderEl = dialogEl.querySelector('.shoppable-popup-Swiper');
    if (popupSliderEl && popupSliderEl.slider) {
      var slides = popupSliderEl.querySelectorAll('.thumb-item, .swiper-slide');
      var targetIndex = 0;
      for (var t = 0; t < slides.length; t++) {
        var dc = slides[t].getAttribute('data-content');
        if (dc === contentEl.id || dc === altContentId || dc === contentId) {
          targetIndex = t;
          break;
        }
      }

      try { popupSliderEl.slider.slideTo(targetIndex); } catch (ee) {}

      var self = this;
      var done = false;
      function confirmMark() {
        if (done) return;
        done = true;

        // Bail out if a newer _openDialogFromTrigger call has started since
        if (myToken !== self._dialogOpenToken) return;

        try {
          var s = popupSliderEl.querySelectorAll('.thumb-item, .swiper-slide');
          if (s && s[targetIndex]) {
            self._markSelectedThumb(s[targetIndex], popupSliderEl);
            // Re-run through the shared activator instead of a raw classList.add,
            // so it re-clears siblings defensively even here.
            self._activateContent(contentEl, dialogEl);
          }
        } catch (e) {}
      }

      try {
        var si = popupSliderEl.slider;
        if (si && typeof si.once === 'function') {
          si.once('slideChange', confirmMark);
          si.once('transitionEnd', confirmMark);
        } else if (si && typeof si.on === 'function') {
          var onSlide = function () { confirmMark(); try { si.off('slideChange', onSlide); } catch (_) {} };
          var onTrans = function () { confirmMark(); try { si.off('transitionEnd', onTrans); } catch (_) {} };
          try { si.on('slideChange', onSlide); } catch (_) {}
          try { si.on('transitionEnd', onTrans); } catch (_) {}
        }
      } catch (e) {}

      this._dialogConfirmTimer = setTimeout(confirmMark, 400);
    }
  } catch (e) {}
}

  /* ---------- Popup slider binding (attach listeners to each popup) ---------- */
  _bindPopupSliders() {
    var popupEls = this.querySelectorAll('.shoppable-popup-Swiper');
    for (var i = 0; i < popupEls.length; i++) {
      this._bindSinglePopup(popupEls[i]);
    }
  }

  _bindSinglePopup(popupEl) {
    var self = this;
    var attempts = 0;

    function tryAttach() {
      var swiperInstance = popupEl.slider;
      if (!swiperInstance) {
        attempts++;
        if (attempts < 30) {
          setTimeout(tryAttach, 100);
        }
        return;
      }

      try {
        if (typeof swiperInstance.on === 'function') {
          swiperInstance.on('slideChange', function () {
            var idx = typeof swiperInstance.activeIndex !== 'undefined' ? swiperInstance.activeIndex : 0;
            self._activateContentByThumbIndex(popupEl, idx);
            var slides = popupEl.querySelectorAll('.thumb-item, .swiper-slide');
            if (slides && slides[idx]) self._markSelectedThumb(slides[idx], popupEl);
          });

          swiperInstance.on('transitionEnd', function () {
            var idx2 = typeof swiperInstance.activeIndex !== 'undefined' ? swiperInstance.activeIndex : 0;
            var slides2 = popupEl.querySelectorAll('.thumb-item, .swiper-slide');
            if (slides2 && slides2[idx2]) self._markSelectedThumb(slides2[idx2], popupEl);
          });
        }
      } catch (e) {}

      popupEl.addEventListener('click', function (ev) {
        try {
          var thumb = ev.target.closest && ev.target.closest('.thumb-item, .swiper-slide');
          if (!thumb) return;
          var dataContent = thumb.getAttribute('data-content');
          if (!dataContent) return;
          self._activateContentById(dataContent);
          self._markSelectedThumb(thumb, popupEl);
        } catch (e) {}
      }, true);

      // initial sync: only if dialog already open or content active
      try {
        var idx = (swiperInstance && typeof swiperInstance.activeIndex !== 'undefined') ? swiperInstance.activeIndex : 0;
        var parentDialog = popupEl.closest('dialog-box') || popupEl.closest('.dialog-box');
        var hasActiveContent = parentDialog ? !!parentDialog.querySelector('.video-inner-wrapper.active') : false;

        if ((parentDialog && parentDialog.classList.contains('is-open')) || hasActiveContent) {
          self._activateContentByThumbIndex(popupEl, idx);
          var slides = popupEl.querySelectorAll('.thumb-item, .swiper-slide');
          if (slides && slides[idx]) self._markSelectedThumb(slides[idx], popupEl);
        }
      } catch (e) {}
    }

    tryAttach();
  }

  _activateContentByThumbIndex(popupEl, index) {
    if (!popupEl) return;
    var slides = popupEl.querySelectorAll('.thumb-item, .swiper-slide');
    if (!slides || !slides.length) return;
    var i = parseInt(index, 10);
    if (isNaN(i) || i < 0) i = 0;
    if (i >= slides.length) i = slides.length - 1;
    var dataContent = slides[i].getAttribute('data-content');
    if (!dataContent) return;
    this._activateContentById(dataContent);
    this._markSelectedThumb(slides[i], popupEl);
  }

  _activateContent(contentEl, dialogEl) {
  if (!contentEl) return;

  var scope = dialogEl || contentEl.closest('dialog-box') || contentEl.closest('.dialog-box') || document;
  var allContents = scope.querySelectorAll(
    '.video-inner-wrapper.active, [id^="dialog-content-"].active, [id^="dailog-content-"].active'
  );
  Array.from(allContents).forEach(function (content) {
    if (content !== contentEl) content.classList.remove('active');
  });

  try { contentEl.classList.add('active'); } catch (e) {}

  try {
    var od = contentEl.querySelector('on-demand-media');
    if (od) this._ensureInjected(od);
    else {
      var sv = contentEl.querySelector('video');
      if (sv) this.observeVideo(sv);
    }
  } catch (e) {}
}

 _activateContentById(contentId) {
  if (!contentId) return;
  var el = document.getElementById(contentId)
    || document.getElementById(contentId.replace('dailog', 'dialog'))
    || document.getElementById(contentId.replace('dialog', 'dailog'));
  if (!el) return;

  var parentDialog = el.closest('dialog-box') || el.closest('.dialog-box') || document;
  this._activateContent(el, parentDialog);
}

  /* ---------- Scoped selection marking ---------- */
  _markSelectedThumb(currentSlide, popupEl) {
    if (!popupEl || !currentSlide) return;
    try {
      var all = popupEl.querySelectorAll('.thumb-item, .swiper-slide');
      for (var i = 0; i < all.length; i++) {
        try { all[i].classList.remove('is-selected'); } catch (e) {}
      }
      try { currentSlide.classList.add('is-selected'); } catch (e) {}
    } catch (e) {}
  }

  /* ---------- Patch DialogBox.close to mute videos inside only ---------- */
  _patchDialogClose() {
    if (typeof DialogBox === 'undefined' || !DialogBox.prototype) return;
    var self = this;
    var origClose = DialogBox.prototype.close;
    DialogBox.prototype.close = function () {
      try { origClose.call(this); } catch (e) {}
      try {
        var vids = this.querySelectorAll('video');
        for (var i = 0; i < vids.length; i++) {
          try {
            vids[i].muted = true;
            if (self.contains(vids[i])) self._syncMuteButtons(vids[i]);
          } catch (e) {}
        }
      } catch (e) {}
    };
    var openDialogs = document.querySelectorAll('dialog.is-active,dialog.is-open,.dialog.is-active,.dialog.is-open');
    if (openDialogs.length === 0) {
      document.body.classList.remove('overflow-hide');
    }
  }

  /* ---------- Initial scan: observe static videos & inject autoplay ones ---------- */
  _scanExistingVideos() {
    try {
      var vids = this.querySelectorAll('video');
      for (var i = 0; i < vids.length; i++) {
        try { this.observeVideo(vids[i]); } catch (e) {}
      }

      var odList = this.querySelectorAll('on-demand-media.autoplay-true, on-demand-media[data-autoplay="true"]');
      for (var j = 0; j < odList.length; j++) {
        try { this._ensureInjected(odList[j]); } catch (e) {}
      }
    } catch (e) {}
  }
}

customElements.define('shoppable-videos', ShoppableVideos);


class FeatureHeroSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.activeIndex = 0;
    this.resizeObserver = null;
    this._visibilityObserver = null;
    this._vendorLoadRequested = false;
    this._boundShopifyBlockSelect = this._onShopifyBlockSelect.bind(this);
    this._boundShopifyBlockDeselect = this._onShopifyBlockDeselect.bind(this);
  }

  connectedCallback() {
    this._scheduleInitSlider();
    window.addEventListener(
      "shopify:block:select",
      this._boundShopifyBlockSelect
    );
    window.addEventListener(
      "shopify:block:deselect",
      this._boundShopifyBlockDeselect
    );
  }

  disconnectedCallback() {
    this.destroySlider();
    if (this._visibilityObserver) {
      try {
        this._visibilityObserver.disconnect();
      } catch (e) {}
      this._visibilityObserver = null;
    }
    window.removeEventListener(
      "shopify:block:select",
      this._boundShopifyBlockSelect
    );
    window.removeEventListener(
      "shopify:block:deselect",
      this._boundShopifyBlockDeselect
    );
  }

  _scheduleInitSlider() {
    if (this.slider || this._visibilityObserver) return;

    this._visibilityObserver = initWhenVisible(this, () => {
      this._visibilityObserver = null;
      this.initSlider();
    });
  }

  initSlider() {
    if (typeof Swiper === "undefined") {
      return;
    }

    this._vendorLoadRequested = false;

    // Destroy existing instance if reinitializing
    if (this.slider) {
      this.slider.destroy(true, true);
      this.slider = null;
    }

    // Get settings from <script type="application/json" class="slider-settings">
    const configScript = this.querySelector(
      'script.slider-settings[type="application/json"]'
    );
    let settings = {};
    if (configScript) {
      try {
        settings = JSON.parse(configScript.textContent.trim());
      } catch (e) {
        console.warn("Invalid JSON in slider-settings:", e);
      }
    }

    // Initialize Swiper
    try {
      this.slider = new Swiper(this, settings);
    } catch (err) {
      console.error("Failed to initialize Swiper:", err);
      return;
    }

    // Bind events

    // Observe for resize updates
    if (typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(() => {
        try {
          this.slider.update();
        } catch (e) {}
      });
      this.resizeObserver.observe(this);
    }
  }

  destroySlider() {
    try {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    } catch (e) {}

    window.removeEventListener(
      "shopify:block:select",
      this._onShopifyBlockSelect.bind(this)
    );
    window.removeEventListener(
      "shopify:block:deselect",
      this._onShopifyBlockDeselect.bind(this)
    );
  }
  _onShopifyBlockSelect(evt) {
    if (!this.slider) return;

    // Detect block ID
    let blockId = evt?.detail?.blockId || evt?.detail?.id || null;
    if (!blockId) return;

    // Stop autoplay if running
    if (this.slider.autoplay && this.slider.autoplay.running) {
      this.slider.autoplay.stop();
      this._autoplayWasRunning = true;
    } else {
      this._autoplayWasRunning = false;
    }

    // Find corresponding slide for this block
    const targetNav = this.querySelector(`#swiper-slide-${blockId}`);
    if (targetNav) {
      const targetIndex = parseInt(
        targetNav.getAttribute("data-swiper-slide-index"),
        10
      );
      if (!isNaN(targetIndex)) {
        if (typeof this.slider.slideToLoop === "function") {
          this.slider.slideToLoop(targetIndex);
        } else {
          this.slider.slideTo(targetIndex);
        }
      }
    }
  }

  _onShopifyBlockDeselect() {
    // Resume autoplay if it was running before block select
    if (this.slider && this.slider.autoplay && this._autoplayWasRunning) {
      this.slider.autoplay.start();
      this._autoplayWasRunning = false;
    }
  }
}

customElements.define("feature-hero-slider-component", FeatureHeroSliderComponent);

/* =========================
   FeatureHero (behaviour for <feature-hero>)
   - Requires FeatureHeroSliderComponent to be defined first
   - Handles: category click → show slider, sync images
             slider slide change → update image
   - ES5-friendly, defensive, scoped to section
   ========================= */

class FeatureHero extends HTMLElement {
  constructor() {
    super();
    this._bound = false;
    this._sliderBindings = []; // keep track of bound sliders
    this._onCategoryClick = this._onCategoryClick.bind(this);
    this._shopifySelectHandler = this._shopifySelectHandler.bind(this);
  }

  connectedCallback() {
    // bind category clicks scoped to this section
    this._bindCategoryClicks();

    // bind existing sliders
    this._bindAllSliders();

    // listen for shopify editor block select if available (optional)
    try {
      window.addEventListener('shopify:block:select', this._shopifySelectHandler);
      window.addEventListener('shopify:block:deselect', this._shopifySelectHandler);
    } catch (e) {}

    this._bound = true;
  }

  disconnectedCallback() {
    this._unbindCategoryClicks();
    this._unbindAllSliders();
    try {
      window.removeEventListener('shopify:block:select', this._shopifySelectHandler);
      window.removeEventListener('shopify:block:deselect', this._shopifySelectHandler);
    } catch (e) {}
    this._bound = false;
  }

  /* ---------- Category click binding ---------- */
  _bindCategoryClicks() {
    try {
      var nodes = this.querySelectorAll('[data-category-selector]');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].addEventListener('click', this._onCategoryClick);
      }
    } catch (e) {}
  }

  _unbindCategoryClicks() {
    try {
      var nodes = this.querySelectorAll('[data-category-selector]');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].removeEventListener('click', this._onCategoryClick);
      }
    } catch (e) {}
  }

  _onCategoryClick(e) {
    try {
      var btn = e.currentTarget || e.target;
      if (!btn) return;
      var category = btn.getAttribute('data-category');
      if (!category) return;

      // update category active class (scoped)
      this._setActiveCategoryButton(btn);

      // show slider for this category, hide others
      this._showSliderForCategory(category);
    } catch (err) {}
  }

  _setActiveCategoryButton(activeBtn) {
    try {
      var list = this.querySelectorAll('[data-category-selector]');
      for (var i = 0; i < list.length; i++) {
        try { list[i].classList.remove('active'); } catch (_) {}
      }
      try { activeBtn.classList.add('active'); } catch (_) {}
    } catch (e) {}
  }

  /* ---------- Show/hide sliders ---------- */
  _showSliderForCategory(category) {
    if (!category) return;
    try {
      var sliders = this.querySelectorAll('feature-hero-slider-component.feature-hero-slider, feature-hero-slider-component');
      var target = null;
      for (var i = 0; i < sliders.length; i++) {
        var s = sliders[i];
        var sCategory = s.getAttribute('data-category');
        if (sCategory === category) {
          target = s;
          // show
          try {
            s.classList.add('active');
            s.removeAttribute('hidden');
          } catch (e) {}
        } else {
          // hide others
          try {
            s.classList.remove('active');
            s.setAttribute('hidden', '');
          } catch (e) {}
        }
      }

      // If found, sync the feature image to the first slide of that slider
      if (target) {
        this._ensureSliderBound(target);
        this._showImageForSliderFirstSlide(target);
      }
    } catch (e) {}
  }

  /* ---------- Show image for slider's first slide ---------- */
  _showImageForSliderFirstSlide(sliderEl) {
    if (!sliderEl) return;
    try {
      // find first slide element inside slider
      var firstSlide = sliderEl.querySelector('.swiper-wrapper .swiper-slide');
      if (!firstSlide) {
        // if slider has no slides (edge-case), hide all images
        this._hideAllImages();
        return;
      }
      var blockId = this._getBlockIdFromSlide(firstSlide);
      if (!blockId) {
        this._hideAllImages();
        return;
      }
      this._showImageByBlockId(blockId);
    } catch (e) {}
  }

  _getBlockIdFromSlide(slideEl) {
    if (!slideEl) return null;
    try {
      var id = slideEl.id || '';
      // expected pattern: swiper-slide-<blockId>
      if (id.indexOf('swiper-slide-') === 0) {
        return id.replace('swiper-slide-', '');
      }
      // some markup might use shopify-block-<id>
      if (id.indexOf('shopify-block-') === 0) {
        return id.replace('shopify-block-', '');
      }
      // fallback: check data-block attribute on corresponding image mapping (rare)
      return null;
    } catch (e) {
      return null;
    }
  }

  _showImageByBlockId(blockId) {
    if (!blockId) return;
    try {
      var images = this.querySelectorAll('.feature-hero-image');
      for (var i = 0; i < images.length; i++) {
        try {
          var img = images[i];
          if (img.id === 'feature-hero-image-' + blockId) {
            // show this image
            try { img.removeAttribute('hidden'); } catch (_) {}
          } else {
            try { img.setAttribute('hidden', ''); } catch (_) {}
          }
        } catch (e) {}
      }
    } catch (e) {}
  }

  _hideAllImages() {
    try {
      var images = this.querySelectorAll('.feature-hero-image');
      for (var i = 0; i < images.length; i++) {
        try { images[i].setAttribute('hidden', ''); } catch (e) {}
      }
    } catch (e) {}
  }

  /* ---------- Slider binding / slide change handling ---------- */
  _bindAllSliders() {
    try {
      var sliders = this.querySelectorAll('feature-hero-slider-component');
      for (var i = 0; i < sliders.length; i++) {
        this._bindSingleSlider(sliders[i]);
      }
    } catch (e) {}
  }

  _unbindAllSliders() {
    try {
      for (var i = 0; i < this._sliderBindings.length; i++) {
        var item = this._sliderBindings[i];
        try {
          if (item.sliderInstance && typeof item.sliderInstance.off === 'function') {
            item.sliderInstance.off('slideChange', item.fn);
            item.sliderInstance.off('transitionEnd', item.fnTrans);
          }
        } catch (e) {}
      }
      this._sliderBindings = [];
    } catch (e) {}
  }

  _ensureSliderBound(sliderEl) {
    // ensure binding exists (useful if slider was initially not bound)
    try {
      var found = false;
      for (var i = 0; i < this._sliderBindings.length; i++) {
        if (this._sliderBindings[i].sliderEl === sliderEl) {
          found = true;
          break;
        }
      }
      if (!found) this._bindSingleSlider(sliderEl);
    } catch (e) {}
  }

  _bindSingleSlider(sliderEl) {
    if (!sliderEl) return;
    var self = this;
    var attempts = 0;

    function tryAttach() {
      var sliderInstance = sliderEl.slider; // your FeatureHeroSliderComponent stores Swiper in .slider
      if (!sliderInstance) {
        attempts++;
        if (attempts < 30) {
          setTimeout(tryAttach, 100);
        }
        return;
      }

      // attach handlers (keep references for off)
      var onSlideChange = function () {
        try {
          // active slide element (Swiper stores slides in sliderInstance.slides array)
          var idx = typeof sliderInstance.activeIndex !== 'undefined' ? sliderInstance.activeIndex : 0;
          // Swiper may have virtual slides or loop; normalize to visible slide element
          var slideEls = sliderEl.querySelectorAll('.swiper-slide');
          var activeSlide = slideEls && slideEls[idx] ? slideEls[idx] : slideEls[0];
          if (!activeSlide) return;

          var blockId = self._getBlockIdFromSlide(activeSlide);
          if (blockId) self._showImageByBlockId(blockId);
        } catch (e) {}
      };

      var onTrans = function () {
        // same as slideChange — ensure image synced after transitionEnd
        try {
          var idx = typeof sliderInstance.activeIndex !== 'undefined' ? sliderInstance.activeIndex : 0;
          var slideEls = sliderEl.querySelectorAll('.swiper-slide');
          var activeSlide = slideEls && slideEls[idx] ? slideEls[idx] : slideEls[0];
          if (!activeSlide) return;
          var blockId = self._getBlockIdFromSlide(activeSlide);
          if (blockId) self._showImageByBlockId(blockId);
        } catch (e) {}
      };

      try {
        if (typeof sliderInstance.on === 'function') {
          sliderInstance.on('slideChange', onSlideChange);
          sliderInstance.on('transitionEnd', onTrans);
        }
      } catch (e) {}

      // store binding so we can cleanup easily
      self._sliderBindings.push({
        sliderEl: sliderEl,
        sliderInstance: sliderInstance,
        fn: onSlideChange,
        fnTrans: onTrans
      });

      // initial sync: if this slider is visible (no hidden attr and has active class), show its first slide image
      try {
        if (!sliderEl.hasAttribute('hidden') && sliderEl.classList.contains('active')) {
          self._showImageForSliderFirstSlide(sliderEl);
        }
      } catch (e) {}
    }

    tryAttach();
  }

  /* ---------- Optional: shopify block select integration ---------- */
  _shopifySelectHandler(evt) {
    try {
      var detail = (evt && evt.detail) ? evt.detail : null;
      if (!detail) return;
      var blockId = detail.blockId || detail.id || null;
      if (!blockId) return;

      // find the slide element in this section
      var slideSel = this.querySelector('#swiper-slide-' + blockId);
      if (!slideSel) return;

      // find its parent slider component
      var parentSlider = slideSel.closest('feature-hero-slider-component');
      if (!parentSlider) return;

      // determine its category and show the slider
      var category = parentSlider.getAttribute('data-category');
      if (!category) return;

      // Update the category button active state (scoped to this section)
      try {
        var catBtn = this.querySelector('[data-category="' + category + '"]');
        if (catBtn) {
          this._setActiveCategoryButton(catBtn);
        }
      } catch (e) {}

      // show correct slider for this category (this also syncs the image)
      try {
        this._showSliderForCategory(category);
      } catch (e) {}

      // ensure slider is bound and then slide to the target index if possible
      try {
        var si = parentSlider.slider;
        if (si) {
          // Determine index within DOM slides (use DOM order of .swiper-slide)
          var slideEls = parentSlider.querySelectorAll('.swiper-slide');
          var targetIndex = 0;
          for (var i = 0; i < slideEls.length; i++) {
            if (slideEls[i].id === 'swiper-slide-' + blockId) {
              targetIndex = i;
              break;
            }
          }
          try {
            if (typeof si.slideTo === 'function') si.slideTo(targetIndex);
            else if (typeof si.slideToLoop === 'function') si.slideToLoop(targetIndex);
          } catch (e) {}
        }
      } catch (e) {}
    } catch (e) {}
  }
}

customElements.define('feature-hero', FeatureHero);
class ElementQty extends HTMLElement {
  constructor() {
    super();

    this._initialized = false;

    // Bind handlers so we can remove them if needed
    this._onMinusClick = this._onMinusClick.bind(this);
    this._onPlusClick = this._onPlusClick.bind(this);
    this._onInputBlur = this._onInputBlur.bind(this);
    this._onInputTyping = this._onInputTyping.bind(this);
    this._onInputFocus = this._onInputFocus.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.input = this.querySelector('.quantity-text-input');
    this.minusBtn = this.querySelector('.product-qty-minus');
    this.plusBtn  = this.querySelector('.product-qty-plus');

    if (!this.input || !this.minusBtn || !this.plusBtn) return;

    // Optional: auto-submit closest form (for PDP) via attribute
    // For cart drawer/page set data-auto-submit="false"
    this.autoSubmit = this.getAttribute('data-auto-submit') === 'true';

    this.minusBtn.addEventListener('click', this._onMinusClick);
    this.plusBtn.addEventListener('click', this._onPlusClick);
    this.input.addEventListener('blur', this._onInputBlur);
    this.input.addEventListener('input', this._onInputTyping);
    this.input.addEventListener('focus', this._onInputFocus);

    // store initial as previous qty
    var initial = parseInt(this.input.value, 10);
    if (!isNaN(initial)) {
      this.input.setAttribute('data-prev-qty', String(initial));
    }
  }

  disconnectedCallback() {
    if (!this._initialized) return;
    this._initialized = false;

    if (this.minusBtn) this.minusBtn.removeEventListener('click', this._onMinusClick);
    if (this.plusBtn) this.plusBtn.removeEventListener('click', this._onPlusClick);
    if (this.input) {
      this.input.removeEventListener('blur', this._onInputBlur);
      this.input.removeEventListener('input', this._onInputTyping);
      this.input.removeEventListener('focus', this._onInputFocus);
    }
  }

  // ---- Helpers ----
  _getMin() {
    var minAttr = this.input.getAttribute('min');
    var min = parseInt(minAttr, 10);
    return isNaN(min) ? 1 : min;
  }

  _getMax() {
    var maxAttr = this.input.getAttribute('max');
    var max = parseInt(maxAttr, 10);
    return isNaN(max) ? null : max;
  }

  _getStep() {
    var stepAttr = this.input.getAttribute('step');
    var step = parseInt(stepAttr, 10);
    if (isNaN(step) || step <= 0) step = 1;
    return step;
  }

  _normalizeValue(raw) {
    var min = this._getMin();
    var max = this._getMax();
    var step = this._getStep();

    var val = parseInt(raw, 10);
    if (isNaN(val)) val = min;

    if (val < min) val = min;
    if (max !== null && val > max) val = max;

    // Align to step relative to min
    var offset = val - min;
    if (offset % step !== 0) {
      val = min + Math.round(offset / step) * step;
      if (val < min) val = min;
      if (max !== null && val > max) val = max;
    }

    return val;
  }

  _setValue(newValue) {
    var normalized = this._normalizeValue(newValue);
    if (String(normalized) === this.input.value) return;

    this.input.value = normalized;

    // Bubble events so cart.js can listen (change handler triggers CartStore.changeLine)
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.dispatchEvent(new Event('change', { bubbles: true }));

    if (this.autoSubmit) {
      var form = this.input.form || this.closest('form');
      if (form) {
        clearTimeout(form._qtySubmitTimer);
        form._qtySubmitTimer = setTimeout(function () {
          form.submit();
        }, 250);
      }
    }
  }

  // ---- Event handlers ----
  _onMinusClick() {
    var step = this._getStep();
    var current = this._normalizeValue(this.input.value);

    // store previous value before change
    this.input.setAttribute('data-prev-qty', String(current));

    var min = this._getMin();
    var newVal = current - step;
    if (newVal < min) newVal = min;
    this._setValue(newVal);
  }

  _onPlusClick() {
    var step = this._getStep();
    var current = this._normalizeValue(this.input.value);

    // store previous value before change
    this.input.setAttribute('data-prev-qty', String(current));

    var max = this._getMax();
    var newVal = current + step;
    if (max !== null && newVal > max) newVal = max;
    this._setValue(newVal);
  }

  _onInputBlur() {
    // normalize on blur (previous value already stored on focus)
    this._setValue(this.input.value);
  }

  _onInputTyping() {
    // allow empty while typing; normalize on blur
    if (this.input.value === '') return;
    var digits = this.input.value.replace(/[^\d]/g, '');
    if (digits !== this.input.value) {
      this.input.value = digits;
    }
  }

  _onInputFocus() {
    var current = this._normalizeValue(this.input.value);
    this.input.setAttribute('data-prev-qty', String(current));
  }
}

// Register the custom element
if (!customElements.get('element-qty')) {
  customElements.define('element-qty', ElementQty);
}

class RecommendationsPdt extends HTMLElement {
  constructor() {
    super();
    this._observer = null;
    this._loaded = false;

    this._handleIntersection = this._handleIntersection.bind(this);
  }

  connectedCallback() {
    if (this._loaded || this.getAttribute('data-loaded') === 'true') {
      return;
    }

    var url = this.getAttribute('data-url');
    if (!url) return;

    // Lazy-load when near viewport
    if ('IntersectionObserver' in window) {
      this._observer = new IntersectionObserver(this._handleIntersection, {
        rootMargin: '300px',
      });
      this._observer.observe(this);
    } else {
      // Fallback: load immediately
      this._loadRecommendations();
    }
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  }

  _handleIntersection(entries) {
    for (var i = 0; i < entries.length; i++) {
      var entry = entries[i];
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        if (!this._loaded) {
          this._loadRecommendations();
        }
        if (this._observer) {
          this._observer.disconnect();
          this._observer = null;
        }
        break;
      }
    }
  }

  _loadRecommendations() {
    if (this._loaded) return;
    this._loaded = true;
    this.setAttribute('data-loaded', 'true');

    var url = this.getAttribute('data-url');
    if (!url) return;

    var _this = this;

    fetch(url)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Network error: ' + response.status);
        }
        return response.text();
      })
      .then(function (html) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;

        // The section HTML should contain an element with data-product-recommendations
        var returned = wrapper.querySelector('[data-product-recommendations]');
        if (!returned) {
          _this.style.display = 'none';
          if (_this.closest('cart-recommendations')) {
            _this.innerHTML = '';
          }
          return;
        }

        // Replace current content with the server-rendered content
        _this.innerHTML = returned.innerHTML;
        
        // If there are no items, hide
        var item = _this.querySelector('.recommendations-pdt-item,.recommended-product-item');
        _this.dispatchEvent(
          new CustomEvent('recommendations:status', {
            detail: {
              loaded: !!item
            },
            bubbles: true
          })
        );
        if (!item) {
          _this.style.display = 'none';
          if (_this.closest('cart-recommendations')) {
            _this.innerHTML = '';
          }
          return;
        }

        // Let your existing slider-component JS take over
        // If your slider code auto-inits via MutationObserver / DOMContentLoaded,
        // you don't need anything here. These are just "nice to have" hooks:

        var sliders = _this.querySelectorAll('slider-component');
        for (var i = 0; i < sliders.length; i++) {
          var slider = sliders[i];

          // If your slider-component exposes an init() method, call it
          if (typeof slider.init === 'function') {
            try {
              slider.init();
            } catch (e) {
              console.warn('slider-component init error', e);
            }
          }

          // Also emit a custom event in case your slider JS listens to it
          try {
            slider.dispatchEvent(
              new CustomEvent('slider:mount', {
                bubbles: true,
              })
            );
          } catch (e) {
            // ignore for older browsers without CustomEvent support
          }
        }
      })
      .catch(function (err) {
        _this.dispatchEvent(
          new CustomEvent('recommendations:status', {
            detail: { loaded: false },
            bubbles: true
          })
        );
        console.error('Error loading complementary products:', err);
        _this.style.display = 'none';
      });
  }
}

  if (!customElements.get('recommendations-pdt')) {
    customElements.define('recommendations-pdt', RecommendationsPdt);
  }


class ContentTabs extends HTMLElement {
  constructor() {
    super();
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback() {
    // Cache DOM
    this.tabList = this.querySelector('.shp-tab-list');
    this.tabLinks = this.tabList
      ? this.tabList.querySelectorAll('[data-tab-index]')
      : [];
    this.panels = this.querySelectorAll('[data-tab-panel]');

    if (!this.tabList || !this.tabLinks.length || !this.panels.length) {
      return;
    }

    // Ensure one tab is active
    if (!this._hasActiveTab()) {
      this._activateByIndex(0);
    } else {
      // Sync panels with whatever is marked active in Liquid
      const activeLink = Array.prototype.find.call(
        this.tabLinks,
        (link) => link.classList.contains('active')
      );
      if (activeLink) {
        const idx = activeLink.getAttribute('data-tab-index');
        this._activateTab(idx);
      }
    }

    // Attach event listener
    this.tabList.addEventListener('click', this._onClick);
  }

  disconnectedCallback() {
    if (this.tabList) {
      this.tabList.removeEventListener('click', this._onClick);
    }
  }

  // ---------- Internal helpers ----------

  _onClick(event) {
    let target = event.target;
    if (!target) return;

    // If a child inside <a> was clicked
    if (!target.hasAttribute('data-tab-index')) {
      if (typeof target.closest === 'function') {
        target = target.closest('[data-tab-index]');
      } else {
        // Fallback walk for older browsers
        while (target && target !== this.tabList && !target.getAttribute('data-tab-index')) {
          target = target.parentNode;
        }
      }
    }

    if (!target || !target.getAttribute) return;

    const tabIndex = target.getAttribute('data-tab-index');
    if (!tabIndex) return;

    event.preventDefault();
    this._activateTab(tabIndex);
  }

  _hasActiveTab() {
    for (let i = 0; i < this.tabLinks.length; i++) {
      if (this.tabLinks[i].classList.contains('active')) return true;
    }
    return false;
  }

  _activateByIndex(index) {
    if (index < 0 || index >= this.tabLinks.length) return;
    const link = this.tabLinks[index];
    const tabIndex = link.getAttribute('data-tab-index');
    if (tabIndex) this._activateTab(tabIndex);
  }

  _activateTab(tabIndex) {
    let i;

    // Deactivate all headers
    for (i = 0; i < this.tabLinks.length; i++) {
      this.tabLinks[i].classList.remove('active');
      this.tabLinks[i].setAttribute('aria-selected', 'false');
    }

    // Activate selected header
    for (i = 0; i < this.tabLinks.length; i++) {
      if (this.tabLinks[i].getAttribute('data-tab-index') === tabIndex) {
        this.tabLinks[i].classList.add('active');
        this.tabLinks[i].setAttribute('aria-selected', 'true');
        break;
      }
    }

    // Hide all panels
    for (i = 0; i < this.panels.length; i++) {
      this.panels[i].classList.remove('active');
    }

    // Show matching panel
    for (i = 0; i < this.panels.length; i++) {
      if (this.panels[i].getAttribute('data-tab-panel') === tabIndex) {
        this.panels[i].classList.add('active');
        break;
      }
    }
  }
}

// Define the custom element (once)
if (!customElements.get('content-tabs')) {
  customElements.define('content-tabs', ContentTabs);
}


class ProductMediaSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.lightbox = null;
    this.activeIndex = 0;
    this.resizeObserver = null;
    this._vendorLoadRequested = false;
    this._lightboxVendorRequested = false;
  }

  connectedCallback() {
    this.initSlider();
  }

  disconnectedCallback() {
    this.destroySlider();
  }

  initSlider() {
    if (typeof Swiper === "undefined") {
      return;
    }

    this._vendorLoadRequested = false;

    if (this.slider) {
      try {
        this.slider.destroy(true, true);
      } catch (e) {}
      this.slider = null;
    }

    var configScript = this.querySelector(
      'script.slider-settings[type="application/json"]'
    );
    var settings = {};
    if (configScript) {
      try {
        settings = JSON.parse(configScript.textContent.trim());
      } catch (e) {
        console.warn("Invalid JSON in slider-settings:", e);
      }
    }

    try {
      this.slider = new Swiper(this, settings);
    } catch (err) {
      console.error("Failed to initialize Swiper:", err);
      return;
    }

    this.activeIndex =
      (typeof this.slider.realIndex === "number"
        ? this.slider.realIndex
        : this.slider.activeIndex) || 0;

    // 🔔 Fire on init
    try {
      var initEvent = new CustomEvent("product-media-slider:initialized", {
        bubbles: true,
        detail: {
          swiper: this.slider,
          activeIndex: this.activeIndex
        }
      });
      this.dispatchEvent(initEvent);
    } catch (e) {}

    var self = this;
    this.slider.on("slideChange", function () {
          self.querySelectorAll("iframe[src*='www.youtube.com']").forEach((video) => {
            video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}',"*");        
          });
          self.querySelectorAll("iframe[src*='player.vimeo.com']").forEach((video) => {
            video.contentWindow.postMessage('{"method":"pause"}', "*");              
          });
          self.querySelectorAll("video").forEach((video) => {
            video.pause();
          });
      self.activeIndex =
        (typeof self.slider.realIndex === "number"
          ? self.slider.realIndex
          : self.slider.activeIndex) || 0;

      try {
        var changeEvent = new CustomEvent(
          "product-media-slider:slide-changed",
          {
            bubbles: true,
            detail: {
              swiper: self.slider,
              activeIndex: self.activeIndex
            }
          }
        );
        self.dispatchEvent(changeEvent);
      } catch (e) {}
    });

    if (typeof ResizeObserver !== "undefined") {
      this.resizeObserver = new ResizeObserver(function () {
        try {
          self.slider.update();
        } catch (e) {}
      });
      this.resizeObserver.observe(this);
    }
  }

  destroySlider() {
    try {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
      if (this.lightbox && typeof this.lightbox.destroy === "function") {
        this.lightbox.destroy();
        this.lightbox = null;
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    } catch (e) {}
  }
}

customElements.define("product-media-slider", ProductMediaSlider);

class SliderProductThumbs extends HTMLElement {
  constructor() {
    super();
    this.thumbs = [];
    this.swiper = null;
    this.sliderEl = null;
    this.activeIndex = 0;
    this.prevBtn = null;
    this.nextBtn = null;
    this.paginationEl = null;
    this._retryTimer = null;
    this._retryCount = 0;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    var list = this.querySelector(".product-thumbs__list");
    if (!list) return;

    this.thumbs = Array.prototype.slice.call(
      list.querySelectorAll(".product-thumb")
    );
    if (!this.thumbs.length) return;

    this.prevBtn = this.querySelector(".thumb-slider-nav-prev");
    this.nextBtn = this.querySelector(".thumb-slider-nav-next");
    this.paginationEl = this.querySelector(".thumb-pagination");

    var self = this;

    // Click on thumbs
    for (var i = 0; i < this.thumbs.length; i++) {
      (function (index) {
        self.thumbs[index].addEventListener("click", function () {
          self.goTo(index, true);
        });
      })(i);
    }

    // Prev / Next
    if (this.prevBtn) {
      this.prevBtn.addEventListener("click", function () {
        self.goTo(self.activeIndex - 1, true);
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener("click", function () {
        self.goTo(self.activeIndex + 1, true);
      });
    }

    // Zigzag layout for left thumbnails (1 / 2-3 / 4 / 5-6 / 7...)
    if (this.getAttribute("data-thumbnail-position") === "left") {
      for (var j = 0; j < this.thumbs.length; j++) {
        if (j % 3 === 0) {
          this.thumbs[j].classList.add("full");
          this.thumbs[j].classList.remove("half");
        } else {
          this.thumbs[j].classList.add("half");
          this.thumbs[j].classList.remove("full");
        }
      }
    }

    // Find main slider element by id
    var targetId = this.getAttribute("data-slider-target-id");
    if (targetId) {
      this.sliderEl = document.getElementById(targetId);
    }

    // Try to attach swiper with retry (in case slider initializes later)
    this.attachSwiperWithRetry();

    // Initial UI
    this.updateActiveClasses(this.activeIndex);
    this.updatePagination();
    this.updateArrowStates();
  }

  attachSwiperWithRetry() {
    var self = this;
    if (!this.sliderEl) return;

    // If already attached, just ensure slideChange listener exists
    if (this.sliderEl.slider && !this.swiper) {
      this.swiper = this.sliderEl.slider;

      this.swiper.on("slideChange", function () {
        var idx =
          typeof self.swiper.realIndex === "number"
            ? self.swiper.realIndex
            : self.swiper.activeIndex || 0;
        self.updateFromSlider(idx);
      });

      // Sync once
      var initialIndex =
        typeof this.swiper.realIndex === "number"
          ? this.swiper.realIndex
          : this.swiper.activeIndex || 0;
      this.updateFromSlider(initialIndex);

      return;
    }

    // If not ready yet, retry a few times
    if (this._retryCount >= 20) {
      return; // give up after ~2s (20 * 100ms)
    }

    this._retryCount += 1;

    if (this._retryTimer) {
      clearTimeout(this._retryTimer);
    }

    this._retryTimer = setTimeout(function () {
      self.attachSwiperWithRetry();
    }, 100);
  }

  goTo(index, updateSlider) {
    if (index < 0) index = 0;
    if (index > this.thumbs.length - 1) index = this.thumbs.length - 1;

    // 🔧 If swiper not attached yet, try again right before using it
    if (!this.swiper && this.sliderEl) {
      this.attachSwiperWithRetry();
    }

    this.activeIndex = index;
    this.updateActiveClasses(index);
    this.updatePagination();
    this.updateArrowStates();

    if (updateSlider && this.swiper) {
      this.swiper.slideTo(index);
    }
  }

  updateFromSlider(index) {
    this.activeIndex = index;
    this.updateActiveClasses(index);
    this.updatePagination();
    this.updateArrowStates();
    this.scrollActiveIntoView();
  }

  updateActiveClasses(activeIndex) {
    for (var i = 0; i < this.thumbs.length; i++) {
      if (i === activeIndex) {
        this.thumbs[i].classList.add("is-active");
      } else {
        this.thumbs[i].classList.remove("is-active");
      }
    }
  }

  updatePagination() {
    if (!this.paginationEl) return;
    if (!this.thumbs.length) {
      this.paginationEl.textContent = "";
      return;
    }
    this.paginationEl.textContent =
      this.activeIndex + 1 + " / " + this.thumbs.length;
  }

  updateArrowStates() {
    if (this.prevBtn) {
      if (this.activeIndex <= 0) {
        this.prevBtn.setAttribute("disabled", "disabled");
      } else {
        this.prevBtn.removeAttribute("disabled");
      }
    }

    if (this.nextBtn) {
      if (this.activeIndex >= this.thumbs.length - 1) {
        this.nextBtn.setAttribute("disabled", "disabled");
      } else {
        this.nextBtn.removeAttribute("disabled");
      }
    }
  }

  scrollActiveIntoView() {
    var activeThumb = this.thumbs[this.activeIndex];
    if (!activeThumb || typeof activeThumb.scrollIntoView !== "function") {
      return;
    }

    var position =
      this.getAttribute("data-thumbnail-position") || "right";

    activeThumb.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      behavior: "smooth"
    });
  }
}

customElements.define("slider-product-thumbs", SliderProductThumbs);


class ShowcaseScrollBlock extends HTMLElement {
  constructor() {
    super();

    this.items = [];
    this.textBlock = null;

    this.lastScrollY = window.scrollY;
    this.offset = 0;
    this.active = false;
    this.raf = null;

    // 🔧 CONFIG (simple & predictable)
    this.IMAGE_FACTOR = 0.20;
    this.TEXT_FACTOR = 0.35;
    this.MAX_OFFSET = 250;

    this._loop = this._loop.bind(this);
  }

  // connectedCallback() {
  //   this.items = Array.from(
  //     this.querySelectorAll('.showcase-scroll-motion')
  //   );
  //   this.textBlock = this.querySelector('.showcase-scroll-blocks-text');

  //   if (!this.items.length && !this.textBlock) return;

  //   this._initObserver();
  // }

  disconnectedCallback() {
    this._destroyObserver();
    this._stop();
  }

  /* ----------------------------
     Intersection Observer
  ----------------------------- */
  _initObserver() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        entry.isIntersecting ? this._start() : this._stop();
      },
      { threshold: 0.15 }
    );
    this.observer.observe(this);
  }

  _destroyObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  /* ----------------------------
     RAF loop
  ----------------------------- */
  _start() {
    if (this.active) return;
    this.active = true;
    this.lastScrollY = window.scrollY;
    this.raf = requestAnimationFrame(this._loop);
  }

  _stop() {
    this.active = false;
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = null;
  }

  _loop() {
    if (!this.active) return;

    const currentY = window.scrollY;
    const delta = currentY - this.lastScrollY;

    if (delta !== 0) {
      // accumulate offset directly
      this.offset += delta;

      // clamp
      this.offset = Math.max(
        -this.MAX_OFFSET,
        Math.min(this.MAX_OFFSET, this.offset)
      );

      this.lastScrollY = currentY;
    }

    this._apply();
    this.raf = requestAnimationFrame(this._loop);
  }

  /* ----------------------------
     Apply transforms
  ----------------------------- */
  _apply() {
    this.items.forEach((el, index) => {
      const depth = (index + 1) / this.items.length;

      // scroll down (+delta) → move UP (-Y)
      const move = -this.offset * this.IMAGE_FACTOR * depth;

      el.style.setProperty(
        '--scroll-shift',
        `${move.toFixed(2)}px`
      );
    });

    if (this.textBlock) {
      const textMove = -this.offset * this.TEXT_FACTOR;
      this.textBlock.style.setProperty(
        '--text-shift',
        `${textMove.toFixed(2)}px`
      );
    }
  }
}

customElements.define('showcase-scroll-block', ShowcaseScrollBlock);

/* ============================================================
   QUICK VIEW – AJAX + dialog-box compatible
   ============================================================ */

class ProductQuickView extends HTMLElement {
  constructor() {
    super();
    this._onClick = this._onClick.bind(this);
    this._onButtonKeyDown = this._onButtonKeyDown.bind(this); 
    this._abortController = null;

    this._triggerEl = null;
  }

  connectedCallback() {
    this.addEventListener('click', this._onClick);
    this.addEventListener("keydown", this._onButtonKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick);
    this.removeEventListener("keydown", this._onButtonKeyDown);
    if (this._abortController) {
      this._abortController.abort();
      this._abortController = null;
    }
  }

  /* ------------------------------------------------------------
     CLICK HANDLER
  ------------------------------------------------------------ */
  _onClick(e) {
    e.preventDefault();
 
    this._triggerEl = e.currentTarget || this;
    const handle = this.dataset.productHandle;
    if (!handle) return;

    const dialog = document.querySelector('#quick-view-dialog');
    if (!dialog) return;

    const contentHost = dialog.querySelector('.dialog-content-quick-view');
    if (!contentHost) return;

    // Abort previous request if any
    if (this._abortController) {
      this._abortController.abort();
    }
    this._abortController = new AbortController();

    // UI loading state (optional)
    this.classList.add('is-loading');

    // Clear old content BEFORE opening
    contentHost.innerHTML = '';

    // Open dialog first (nice UX)

    const url = `${handle}?section_id=${dialog.dataset.section}`;

    fetch(url, { signal: this._abortController.signal })
      .then((res) => {
        if (!res.ok) throw new Error('Quick view fetch failed');
        return res.text();
      })
      .then((htmlText) => {
        const doc = new DOMParser().parseFromString(htmlText, 'text/html');

        // 🔑 IMPORTANT:
        // We ONLY extract the inner quick view content
        const incomingContent = doc.querySelector('.dialog-content-quick-view');
        if (!incomingContent) {
          throw new Error('Quick view content not found');
        }

        // Inject ONLY inner content
        contentHost.innerHTML = incomingContent.innerHTML;

        // Re-init Shopify features if needed
        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        if (window.ProductModel) {
          window.ProductModel.loadShopifyXR();
        }

        // Optional: pause background videos
        if (typeof window.pauseVideo === 'function') {
          window.pauseVideo();
        }

        dialog.open();
        dialog._targetEl  = this._triggerEl; // for returning focus later
        // Cleanup when dialog closes
        this._attachCleanup(dialog, contentHost);
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('[Quick View]', err);
          dialog.close();
        }
      })
      .finally(() => {
        this.classList.remove('is-loading');
      });
  }


  _onButtonKeyDown(e){
    var code = e.code || e.key;
    if (
      code === "Enter" ||
      code === " " ||
      code === "Spacebar" ||
      code === "Space"
    ) {
      e.preventDefault();
      this._onClick(e);
    }
  };
  /* ------------------------------------------------------------
     CLEANUP ON CLOSE
  ------------------------------------------------------------ */
  _attachCleanup(dialog, contentHost) {
    const cleanup = () => {
      contentHost.innerHTML = '';
      dialog.removeEventListener('quickview:close', cleanup);
    };

    // Listen only once
    dialog.addEventListener('quickview:close', cleanup, { once: true });
  }
}

/* ------------------------------------------------------------
   REGISTER ELEMENT
------------------------------------------------------------ */
if (!customElements.get('product-quick-view')) {
  customElements.define('product-quick-view', ProductQuickView);
}
/* ============================================================
   GLOBAL FOCUS TRAP (Reusable for all drawers/modals)
============================================================ */

window.FocusTrap = (function () {
  var trapStack = [];
  var keydownListener = null;

  var focusableSelector = [
    'a[href]',
    'area[href]',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'iframe',
    '[tabindex]:not([tabindex="-1"])',
    '[contenteditable="true"]'
  ].join(',');

  function isVisible(el) {
    if (!el) return false;

    var style = window.getComputedStyle(el);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      el.getClientRects().length > 0
    );
  }

  function getFocusable(container) {
    if (!container) return [];

    var nodes = container.querySelectorAll(focusableSelector);
    var list = [];

    for (var i = 0; i < nodes.length; i++) {
      if (isVisible(nodes[i])) {
        list.push(nodes[i]);
      }
    }

    return list;
  }

  function getCurrentTrap() {
    if (!trapStack.length) return null;
    return trapStack[trapStack.length - 1];
  }

  function isTrapActive(trap) {
    if (!trap || !trap.container) return false;

    var container = trap.container;

    return (
      container.classList.contains('is-active') ||
      container.classList.contains('is-open') ||
      container.hasAttribute('open')
    );
  }

  function onKeydown(e) {
    var currentTrap = getCurrentTrap();
    if (!currentTrap || !isTrapActive(currentTrap)) return;

    var container = currentTrap.container;

    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      e.stopPropagation();

      if (typeof currentTrap.onEscape === 'function') {
        currentTrap.onEscape(container);
      } else {
        releaseTop();
      }

      return;
    }

    if (e.key !== 'Tab' && e.keyCode !== 9) return;

    var focusables = getFocusable(container);

    if (!focusables.length) {
      e.preventDefault();
      container.focus();
      return;
    }

    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var active = document.activeElement;

    if (!container.contains(active)) {
      e.preventDefault();
      first.focus();
      return;
    }

    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
      return;
    }

    if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function attachKeydownListener() {
    if (keydownListener) return;
    keydownListener = onKeydown;
    document.addEventListener('keydown', keydownListener, true);
  }

  function detachKeydownListener() {
    if (!keydownListener) return;
    document.removeEventListener('keydown', keydownListener, true);
    keydownListener = null;
  }

  function trap(container, initialFocusEl, onEscape) {
    if (!container) return;

    // Check if this container is already in the stack
    for (var i = 0; i < trapStack.length; i++) {
      if (trapStack[i].container === container) {
        // Already trapped, just update initial focus target
        return;
      }
    }

    var newTrap = {
      container: container,
      restoreEl: document.activeElement,
      onEscape: onEscape
    };

    // Push to stack
    trapStack.push(newTrap);

    if (!container.hasAttribute('tabindex')) {
      container.setAttribute('tabindex', '-1');
      container.setAttribute('data-focus-trap-tabindex', 'true');
    }

    attachKeydownListener();

    window.setTimeout(function () {
      if (!isTrapActive(newTrap)) return;

      var focusables = getFocusable(container);
      var target =
        initialFocusEl && isVisible(initialFocusEl)
          ? initialFocusEl
          : focusables[0] || container;

      try {
        target.focus();
      } catch (e) {}
    }, 30);
  }

  function releaseTop() {
    if (!trapStack.length) return;

    var trap = trapStack.pop();
    var container = trap.container;
    var restoreEl = trap.restoreEl;

    if (
      container &&
      container.getAttribute('data-focus-trap-tabindex') === 'true'
    ) {
      container.removeAttribute('tabindex');
      container.removeAttribute('data-focus-trap-tabindex');
    }

    // Detach listener if no more traps
    if (!trapStack.length) {
      detachKeydownListener();
    } else {
      // Restore focus to the previous trap if it's still active
      var previousTrap = getCurrentTrap();
      if (previousTrap && isTrapActive(previousTrap)) {
        window.setTimeout(function () {
          var focusables = getFocusable(previousTrap.container);
          var target = focusables[0] || previousTrap.container;
          try {
            target.focus();
            
            // Ensure focus stays within this trap by moving it inside if needed
            if (!previousTrap.container.contains(document.activeElement)) {
              target.focus();
            }
          } catch (e) {}
        }, 50);
      }
    }

    // Restore to the element that triggered this modal if not in a stack anymore
    if (
      !trapStack.length &&
      restoreEl &&
      typeof restoreEl.focus === 'function' &&
      document.contains(restoreEl)
    ) {
      try {
        restoreEl.focus();
      } catch (e) {}
    }
  }

  function release(container) {
    if (!container) {
      releaseTop();
      return;
    }

    // Find and remove the specific container from the stack
    var index = -1;
    for (var i = 0; i < trapStack.length; i++) {
      if (trapStack[i].container === container) {
        index = i;
        break;
      }
    }

    if (index === -1) return;

    var trap = trapStack[index];
    trapStack.splice(index, 1);

    var cont = trap.container;
    if (
      cont &&
      cont.getAttribute('data-focus-trap-tabindex') === 'true'
    ) {
      cont.removeAttribute('tabindex');
      cont.removeAttribute('data-focus-trap-tabindex');
    }

    // Detach listener if no more traps
    if (!trapStack.length) {
      detachKeydownListener();
    } else {
      // Restore focus to the current top trap
      var currentTrap = getCurrentTrap();
      if (currentTrap && isTrapActive(currentTrap)) {
        window.setTimeout(function () {
          var focusables = getFocusable(currentTrap.container);
          var target = focusables[0] || currentTrap.container;
          try {
            target.focus();
            
            // Ensure focus stays within this trap by moving it inside if needed
            if (!currentTrap.container.contains(document.activeElement)) {
              target.focus();
            }
          } catch (e) {}
        }, 50);
      }
    }
  }

  return {
    trap: trap,
    release: release,
    releaseTop: releaseTop,
    getFocusable: getFocusable
  };
})();

class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog-box');
    if (!this.dialog) return;

    const footerenableOnLoad = this.getAttribute('data-enable-footer-trigger') !== 'false';
    if(footerenableOnLoad)
    {
      this.openBtns = document.querySelectorAll('[data-newsletter-popup-open]');
    }

    
    this.lastTrigger = null;

    // Do not show on specific routes
    if (window.location.pathname === '/challenge') return;

    this.cookieName = 'newsletter-popup:discovery';

    this.sectionId = this.getAttribute('data-section-id');

    this.expiryDays = parseInt(this.getAttribute('data-expiry') || '5', 10);

    this._onSectionSelect = this._onSectionSelect.bind(this);
    this._onSectionDeselect = this._onSectionDeselect.bind(this);

    /* ---------------- THEME EDITOR ---------------- */
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:select', this._onSectionSelect);
      document.addEventListener('shopify:section:deselect', this._onSectionDeselect);
    }

    /* ---------------- BUTTON OPEN ---------------- */
    this._bindOpenButtons();

    /* ---------------- FORCE OPEN (FORM STATE) ---------------- */
    if (this._hasFormState()) {
      this.open(true);
      return;
    }

    /* ---------------- NORMAL STOREFRONT ---------------- */
    const enableOnLoad = this.getAttribute('data-enable-on-load') !== 'false';

    if (!(window.Shopify && Shopify.designMode) && !this._getCookie(this.cookieName) && enableOnLoad) {
      this._openWithDelay();
    }
    this._bindCloseTracking();
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:section:select', this._onSectionSelect);
    document.removeEventListener('shopify:section:deselect', this._onSectionDeselect);
  }

  /* ---------------- OPEN BUTTONS ---------------- */

  _bindOpenButtons() {
    var self = this;

    if (!this.openBtns || !this.openBtns.length) return;

    this.openBtns.forEach(function (btn) {
      btn.classList.add('popup-linked');
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        self.lastTrigger = btn;

        self.open(true); // ignore cookie
      });
      btn.addEventListener('keydown', function (e) {
        var code = e.code || e.key;

        if (
          code === 'Enter' ||
          code === ' ' ||
          code === 'Space' ||
          code === 'Spacebar'
        ) {
          e.preventDefault();

          self.lastTrigger = btn;
          self.open(true);
        }
      });
    });
    
  }

  /* ---------------- THEME EDITOR EVENTS ---------------- */

  _onSectionSelect(e) {
    if (!this.sectionId) return;
    if (e.detail.sectionId !== this.sectionId) return;

    this.open(true);
  }

  _onSectionDeselect(e) {
    if (!this.sectionId) return;
    if (e.detail.sectionId !== this.sectionId) return;

    this.close();
  }

  /* ---------------- OPEN ---------------- */

  _openWithDelay() {
    // runAfterPageSettles(() => {
      if (!this.isConnected) return;
      if (this._getCookie(this.cookieName) || this._hasFormState()) return;
      this.open();
    // }, 2000);
  }

  open(ignoreCookie) {
    this.dialog.open();
    // FocusTrap is already managed by dialog.open()
    // No need to call window.FocusTrap.trap() again
  }

  /* ---------------- CLOSE ---------------- */

  close() {
    this.dialog.close();
    // FocusTrap is already managed by dialog.close()
    // No need to call window.FocusTrap.release()

    this._setCookie(this.cookieName, this.expiryDays);

    if (this.lastTrigger) {
      this.lastTrigger.focus();
    }
  }

  _bindCloseTracking() {
    var self = this;

    var closeBtn = this.querySelector('.dialog-close');
    var overlay = this.querySelector('.dialog-overlay');

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        self.close();
      });
    }

    if (overlay) {
      overlay.addEventListener('click', function () {
        self.close();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.dialog.classList.contains('is-open')) {
        self.close();
      }
    });
  }

  /* ---------------- FORM STATE ---------------- */

  _hasFormState() {
    return (
      this.querySelector('.alert-state:not(.form-message__wrapper-email)') ||
      this.querySelector('[aria-invalid="true"]')
    );
  }

  /* ---------------- COOKIE HELPERS ---------------- */

  _getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  _setCookie(name, days) {
    document.cookie =
      name +
      '=true; max-age=' +
      days * 24 * 60 * 60 +
      '; path=/';
  }

  removeCookie(name) {
    document.cookie = name + '=; max-age=0; path=/';
  }
}

customElements.define('newsletter-popup', NewsletterPopup);

class AgeVerificationPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog-box');
    if (!this.dialog) return;

    this.sectionId = this.getAttribute('data-section-id');

    this.cookieApproved = 'age-verification-approved';
    this.cookieDeclined = 'age-verification-declined';

    this.expiryDays = parseInt(
      this.getAttribute('data-expiry') || '10',
      10
    );

    this.verifyContent = this.querySelector('[data-verify-content]');
    this.declineContent = this.querySelector('[data-decline-content]');

    this.acceptBtn = this.querySelector('[data-accept]');
    this.declineBtn = this.querySelector('[data-decline]');
    this.backBtn = this.querySelector('[data-back-to-verify]');

    this._onSectionSelect = this._onSectionSelect.bind(this);
    this._onSectionDeselect = this._onSectionDeselect.bind(this);

    this._bindEvents();

    /* ---------------- THEME EDITOR ---------------- */
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener(
        'shopify:section:select',
        this._onSectionSelect
      );
      document.addEventListener(
        'shopify:section:deselect',
        this._onSectionDeselect
      );
    }

    /* ---------------- STOREFRONT ---------------- */
    if (!Shopify?.designMode) {
      // runAfterPageSettles(() => {
        if (!this.isConnected) return;
        this._handleInitialState();
      // }, 1200);
    }
  }

  disconnectedCallback() {
    document.removeEventListener(
      'shopify:section:select',
      this._onSectionSelect
    );
    document.removeEventListener(
      'shopify:section:deselect',
      this._onSectionDeselect
    );
  }

  /* ---------------- INITIAL STATE ---------------- */
  _handleInitialState() {
    // Approved → never show popup
    if (this._isApproved()) return;

    // Declined before → show decline screen directly
    if (this._isDeclined()) {
      this._showDecline();
      this.dialog.open();
      return;
    }

    // First-time visitor → show verify
    this._showVerify();
    this.dialog.open();
  }

  /* ---------------- THEME EDITOR ---------------- */
  _onSectionSelect(e) {
    if (e.detail.sectionId !== this.sectionId) return;
    this._showVerify();
    this.dialog.open();
  }

  _onSectionDeselect(e) {
    if (e.detail.sectionId !== this.sectionId) return;
    this.dialog.close();
  }

  /* ---------------- EVENTS ---------------- */
  _bindEvents() {
    if (this.acceptBtn) {
      this.acceptBtn.addEventListener('click', () => {
        this._approve();
      });
    }

    if (this.declineBtn) {
      this.declineBtn.addEventListener('click', () => {
        this._decline();
      });
    }

    if (this.backBtn) {
      this.backBtn.addEventListener('click', () => {
        this._showVerify();
        this._clearDecline();
      });
    }
  }

  /* ---------------- STATES ---------------- */
  _showVerify() {
    if (this.verifyContent)
      this.verifyContent.classList.remove('display-none');
    if (this.declineContent)
      this.declineContent.classList.add('display-none');
  }

  _showDecline() {
    if (this.verifyContent)
      this.verifyContent.classList.add('display-none');
    if (this.declineContent)
      this.declineContent.classList.remove('display-none');
  }

  /* ---------------- ACTIONS ---------------- */
  _approve() {
    this._setCookie(this.cookieApproved);
    this._clearDecline();
    this.dialog.close();
  }

  _decline() {
    this._setCookie(this.cookieDeclined);
    this._showDecline();
  }

  /* ---------------- COOKIE HELPERS ---------------- */
  _isApproved() {
    return document.cookie.includes(this.cookieApproved + '=true');
  }

  _isDeclined() {
    return document.cookie.includes(this.cookieDeclined + '=true');
  }

  _setCookie(name) {
    document.cookie = `${name}=true; max-age=${
      this.expiryDays * 24 * 60 * 60
    }; path=/`;
  }

  _clearDecline() {
    document.cookie = `${this.cookieDeclined}=; max-age=0; path=/`;
  }
}

customElements.define(
  'age-verification-popup',
  AgeVerificationPopup
);

class ProductRecentlyViewed extends HTMLElement {
  connectedCallback() {
    var productId = parseInt(this.dataset.productId, 10);
    if (!productId) return;

    var items = [];

    try {
      items = JSON.parse(localStorage.getItem('theme-recently-viewed')) || [];
    } catch (e) {}

    var index = items.indexOf(productId);
    if (index !== -1) items.splice(index, 1);

    items.unshift(productId);
    localStorage.setItem(
      'theme-recently-viewed',
      JSON.stringify(items.slice(0, 12))
    );
  }
}

customElements.define(
  'product-recently-viewed',
  ProductRecentlyViewed
);
class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.searchUrl = this.dataset.url;
    this.limit = parseInt(this.dataset.limit || '8', 10);
    if (this.closest('cart-recommendations')) {
      this.innerHTML = '';
    }
    if (!this.sectionId || !this.searchUrl) return;
    this._load();
  }

  /* ---------------- CORE ---------------- */
  _load() {
    var ids = this._getIds();
    if (!ids.length) {
      this._emitStatus(false, 0);
      this._hide();
      return;
    }
    var query = ids.map(function (id) {
      return 'id:' + id;
    }).join(' OR ');

    var url =
      this.searchUrl +
      '?q=' + encodeURIComponent(query) +
      '&type=product' +
      '&section_id=' + this.sectionId;

    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(this._render.bind(this, ids.length))
      .catch(() => {
        this._emitStatus(false, 0);
        this._hide();
      });
  }

  /* ---------------- RENDER ---------------- */
  _render(count, html) {
    var temp = document.createElement('div');
    temp.innerHTML = html;

    var block = temp.querySelector('recently-viewed-products');
    if (!block || !block.innerHTML.trim()) {
      this._emitStatus(false, 0);
      this._hide();
      if (this.closest('cart-recommendations')) {
        this.innerHTML = '';
      }
      return;
    }

    this.innerHTML = block.innerHTML;
    this._show();
    this._emitStatus(true, count);
  }

  /* ---------------- STORAGE ---------------- */
  _getIds() {
    try {
      return (JSON.parse(
        localStorage.getItem('theme-recently-viewed')
      ) || []).slice(0, this.limit);
    } catch (e) {
      return [];
    }
  }

  /* ---------------- EVENTS ---------------- */
  _emitStatus(loaded, count) {
    this.dispatchEvent(
      new CustomEvent('recently-viewed:status', {
        detail: {
          loaded: loaded,
          count: count
        },
        bubbles: true
      })
    );
  }

  /* ---------------- VISIBILITY ---------------- */
  _hide() {
    if (this.closest('cart-recommendations')) {
      this.style.display = 'none';
      return;
    }
    var section = this.closest('.shopify-section');
    if (section) section.style.display = 'none';
  }

  _show() {
    var section = this.closest('.shopify-section');
    if (section) section.style.display = '';
  }
}

customElements.define(
  'recently-viewed-products',
  RecentlyViewedProducts
);


class CartRecommendations extends HTMLElement {
  connectedCallback() {
    this.headers = this.querySelectorAll('[data-tab-header]');
    this.divider = this.querySelector('.divider');

    this.panels = {
      recommended: this.querySelector('[id^="cart-recommended-products"]'),
      recently: this.querySelector('[id^="cart-recently-viewed-products"]')
    };

    this.enabled = {
      recommended: !!this.panels.recommended,
      recently: !!this.panels.recently
    };
    /* ❌ Both disabled */
    if (!this.enabled.recommended && !this.enabled.recently) {
      this.style.display = 'none';
      return;
    }

    /* Status state
       null = waiting
       true / false = resolved */
    this.state = {
      recommended: this.enabled.recommended ? null : true,
      recently: this.enabled.recently ? null : true
    };

    this._bindEvents();
    this._bindTabs();
  }

  /* ---------------- STATUS EVENTS ---------------- */
  _bindEvents() {
    this.addEventListener('recently-viewed:status', (e) => {
      this.state.recently = e.detail.loaded;
      this._updateUI();
    });

    this.addEventListener('recommendations:status', (e) => {
      this.state.recommended = e.detail.loaded;
      this._updateUI();
    });
  }

  /* ---------------- CORE UI RESOLUTION ---------------- */
  _updateUI() {
    /* Wait until all enabled states are resolved */
    if (
      (this.enabled.recommended && this.state.recommended === null) ||
      (this.enabled.recently && this.state.recently === null)
    ) {
      return;
    }

    const available = {
      recommended: this.state.recommended,
      recently: this.state.recently
    };

    const visibleKeys = Object.keys(available).filter(
      (k) => available[k]
    );

    /* ❌ Nothing available */
    if (visibleKeys.length === 0) {
      this.style.display = 'none';
      return;
    }

    /* ✅ Something available */
    this.style.display = '';
    this.classList.add('loaded');

    this._updateHeaders(available);
    this._activateDefaultTab(visibleKeys);
  }

  /* ---------------- HEADERS ---------------- */
  _updateHeaders(availability) {
    let visibleHeaderCount = 0;

    this.headers.forEach((header) => {
      const panel = this.querySelector('#' + header.dataset.content);
      let show = false;

      if (panel === this.panels.recommended && availability.recommended) {
        show = true;
      }
      if (panel === this.panels.recently && availability.recently) {
        show = true;
      }

      header.style.display = show ? '' : 'none';
      if (show) visibleHeaderCount++;
    });

    if (this.divider) {
      this.divider.style.display =
        visibleHeaderCount > 1 ? '' : 'none';
    }
  }

  /* ---------------- TABS ---------------- */
  _bindTabs() {
    this.headers.forEach((header) => {
      // Needed if not using <button>
      if (!header.hasAttribute('tabindex')) {
        header.setAttribute('tabindex', '0');
      }

      header.addEventListener('click', () => {
        this._handleTabActivate(header);
      });

      header.addEventListener('keydown', (event) => {
        var key = event.key || event.code;

        if (
          key === 'Enter' ||
          key === ' ' ||
          key === 'Spacebar' ||
          key === 'Space'
        ) {
          event.preventDefault();
          this._handleTabActivate(header);
        }
      });
    });
  }

  _handleTabActivate(header) {
    const panel = this.querySelector('#' + header.dataset.content);

    if (!panel || panel.style.display === 'none') return;

    this._activateTab(header);
  }

  _activateDefaultTab(keys) {
    if (this.querySelector('.cart-recommendation-tab-content.is-active')) {
      return;
    }

    const firstKey = keys[0];
    const panel =
      firstKey === 'recommended'
        ? this.panels.recommended
        : this.panels.recently;

    const header = this.querySelector(
      `[data-content="${panel.id}"]`
    );

    if (header) this._activateTab(header);
  }

 _activateTab(activeHeader) {
    const targetId = activeHeader.dataset.content;

    this.headers.forEach((h) => {
      const isActive = h === activeHeader;

      h.classList.toggle('is-active', isActive);
      h.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    Object.values(this.panels).forEach((panel) => {
      if (!panel) return;

      const isActive = panel.id === targetId;

      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }
}

/* SAFE DEFINE */
if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}

// Details and Summary start
const initAnimatedDetails = () => {
  const allDetails = document.querySelectorAll('details');

  allDetails.forEach((el) => {
    if (el.getAttribute('data-details-bound') === 'true') return;

    const summary = el.querySelector('summary');
    if (!summary) return;

    el.setAttribute('data-details-bound', 'true');

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      if (el.open) {
        closeElement(el);
      } else {
        const group = el.closest('.accordion-grid, .key-benefits');

        if (group) {
            group.querySelectorAll('details[open]').forEach((otherEl) => {
                if (otherEl !== el) {
                    closeElement(otherEl);
                }
            });
        }
        openElement(el);
      }
    });
  });
};

// function to handle the closing animation
function closeElement(el) {
    const summary = el.querySelector('summary');
    const startHeight = el.offsetHeight;
    const endHeight = summary.offsetHeight;

    el.animate([
        { height: `${startHeight}px` },
        { height: `${endHeight}px` }
    ], {
        duration: 400,
        easing: 'ease'
    }).onfinish = () => {
        el.open = false;
        el.style.height = '';
    };
}

//  function to handle the opening animation
function openElement(el) {
    const summary = el.querySelector('summary');
    el.open = true;
    const endHeight = el.offsetHeight;
    const startHeight = summary.offsetHeight;

    el.animate([
        { height: `${startHeight}px`, overflow: 'hidden' },
        { height: `${endHeight}px`, overflow: 'hidden' }
    ], {
        duration: 400,
        easing: 'ease'
    }).onfinish = () => {
        el.style.height = '';
    };
}

// Details and Summary End
runWhenIdle(initAnimatedDetails);
document.addEventListener('shopify:section:load', initAnimatedDetails);

// Localization for mobile
const initLocalization = () => {
  const triggers = document.querySelectorAll('[localization-trigger]');
  const closeButtons = document.querySelectorAll('[localization-popup-close]');
  const body = document.body;

  // Helper to sync body scroll
  const updateBodyScroll = () => {
    const anyActive = document.querySelector('[localization-popup].is-active');
    if (anyActive) {
      body.classList.add('overflow-hide');
    } else {
      body.classList.remove('overflow-hide');
    }
  };

  const syncTriggerState = (popup, isExpanded) => {
    const form = popup && popup.closest ? popup.closest('localization-form') : null;
    const trigger = form ? form.querySelector('[localization-trigger]') : null;
    if (trigger) {
      trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }
  };

  const closePopup = (popup) => {
    if (!popup) return;
    popup.classList.remove('is-active');
    syncTriggerState(popup, false);
    updateBodyScroll();
  };

  // 1. Handle Trigger Clicks
  triggers.forEach(trigger => {
    if (trigger.getAttribute('data-localization-bound') === 'true') return;
    trigger.setAttribute('data-localization-bound', 'true');

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const popup = trigger.parentElement.querySelector('[localization-popup]') || 
                    trigger.nextElementSibling;

      if (popup) {
        document.querySelectorAll('[localization-popup]').forEach(other => {
          if (other !== popup) closePopup(other);
        });

        const isActive = popup.classList.contains('is-active');
        if (isActive) {
          closePopup(popup);
        } else {
          popup.classList.add('is-active');
          syncTriggerState(popup, true);
          updateBodyScroll();
        }
      }
    });
  });

  // 2. Handle Close Buttons
  closeButtons.forEach(button => {
    if (button.getAttribute('data-localization-close-bound') === 'true') return;
    button.setAttribute('data-localization-close-bound', 'true');

    button.addEventListener('click', (e) => {
      e.preventDefault();
      const popup = button.closest('[localization-popup]');
      if (popup) {
        closePopup(popup);
      }
    });
  });

  // 3. Global click to close
  if (document.documentElement.getAttribute('data-localization-global-bound') !== 'true') {
    document.documentElement.setAttribute('data-localization-global-bound', 'true');
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[localization-popup]') && !e.target.closest('[localization-trigger]')) {
        document.querySelectorAll('[localization-popup].is-active').forEach(p => closePopup(p));
      }
    });
  }
};

runWhenIdle(initLocalization);
document.addEventListener('shopify:section:load', initLocalization);



const initLocalizationDrag = () => {
  const popups = document.querySelectorAll('[localization-popup]');

  popups.forEach(popup => {
    const handle = popup.querySelector('.mobiledrag, .mobile-drag');
    if (!handle) return;

    let startY = 0;
    let deltaY = 0;
    let maxDeltaY = 0;
    let popupHeight = 0;
    let startTime = 0;
    let isDragging = false;

    // Handle touch start
    handle.addEventListener('touchstart', (e) => {
      // Only trigger if it's a single finger touch
      if (e.touches.length !== 1) return;
      
      isDragging = true;
      startY = e.touches[0].clientY;
      deltaY = 0;
      maxDeltaY = 0;
      popupHeight = popup.offsetHeight;
      startTime = Date.now();

      popup.style.transition = 'none';
      // Prevent other click events from firing while we start dragging
      e.stopPropagation(); 
    }, { passive: true });

    // Handle movement
    document.addEventListener('touchmove', (e) => {
      if (!isDragging) return;

      const currentY = e.touches[0].clientY;
      deltaY = Math.max(0, currentY - startY);
      maxDeltaY = Math.max(maxDeltaY, deltaY);

      // Apply damping so it doesn't just fly off the screen
      const displayDelta = Math.min(deltaY, popupHeight) * 0.95;
      popup.style.transform = `translateY(${displayDelta}px)`;
    }, { passive: false }); // Set to false to allow preventDefault if needed

    // Handle touch end
    document.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;

      const elapsed = Date.now() - startTime;
      const velocity = maxDeltaY / Math.max(elapsed, 1);
      const finalRatio = deltaY / popupHeight;

      // Adjusted thresholds for a snappier "Boutique" feel
      const shouldClose = finalRatio >= 0.25 || (maxDeltaY >= 80 && velocity >= 0.5);

      popup.style.transition = 'transform 0.4s cubic-bezier(0.2, 1, 0.3, 1)';

      if (shouldClose) {
        popup.style.transform = `translateY(100%)`;
        
        // Sync with your existing state classes
        setTimeout(() => {
          popup.classList.remove('is-active');
          document.body.classList.remove('overflow-hide');
          const trigger = popup.closest('localization-form')?.querySelector('[localization-trigger]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
          }
          
          // Reset styles for next open
          setTimeout(() => {
            popup.style.transition = '';
            popup.style.transform = '';
          }, 200);
        }, 300);
      } else {
        // Snap back to original position
        popup.style.transform = 'translateY(0)';
      }
    });
  });
};

// Initialize
runWhenIdle(initLocalizationDrag);
document.addEventListener('shopify:section:load', initLocalizationDrag);




const initFeatureBannerPortal = () => {
  const triggers = document.querySelectorAll('[data-portal-trigger]');
  const body = document.body;

  triggers.forEach(trigger => {
    const parentSlide = trigger.closest('.feature-banner-slide');
    const portal = parentSlide?.querySelector('[data-portal-content]');
    const handle = portal?.querySelector('.mobiledrag');
    const dragTarget = portal?.querySelector('.mobile-drag-content');
    
    if (!trigger || !portal || !dragTarget || !handle) return;

    // --- 1. TELEPORT LOGIC ---
    const openPortal = () => {
      body.appendChild(portal);
      body.classList.add('overflow-hide');

      requestAnimationFrame(() => {
        portal.classList.add('is-active');
        dragTarget.style.transform = 'translateY(0)';
      });
    };

    const closePortal = () => {
      // Check if portal is actually active to prevent redundant returns
      if (!portal.classList.contains('is-active')) return;

      portal.classList.remove('is-active');
      dragTarget.style.transform = 'translateY(100%)';
      body.classList.remove('overflow-hide');

      const handleTransitionEnd = () => {
        if (!portal.classList.contains('is-active')) {
          parentSlide.appendChild(portal); 
          dragTarget.style.transform = '';
          dragTarget.style.transition = '';
        }
        dragTarget.removeEventListener('transitionend', handleTransitionEnd);
      };

      dragTarget.addEventListener('transitionend', handleTransitionEnd);
    };

    // --- 2. DRAG LOGIC ---
    let startY = 0, deltaY = 0, startTime = 0, isDragging = false;

    const onTouchMove = (e) => {
      if (!isDragging) return;
      deltaY = Math.max(0, e.touches[0].clientY - startY);
      dragTarget.style.transform = `translateY(${deltaY * 0.95}px)`;
    };

    const onTouchEnd = () => {
      if (!isDragging) return;
      isDragging = false;
      const velocity = deltaY / (Date.now() - startTime || 1);
      const shouldClose = (deltaY / dragTarget.offsetHeight) > 0.25 || velocity > 0.5;

      dragTarget.style.transition = 'transform 0.4s cubic-bezier(0.2, 1, 0.3, 1)';
      if (shouldClose) { closePortal(); } else { dragTarget.style.transform = 'translateY(0)'; }

      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchend', onTouchEnd);
    };

    handle.addEventListener('touchstart', (e) => {
      isDragging = true;
      startY = e.touches[0].clientY;
      startTime = Date.now();
      dragTarget.style.transition = 'none';
      document.addEventListener('touchmove', onTouchMove, { passive: false });
      document.addEventListener('touchend', onTouchEnd);
    }, { passive: true });

    // --- 3. BIND BUTTONS ---
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      openPortal();
    });

    portal.querySelectorAll('[data-portal-close]').forEach(closeBtn => {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        closePortal();
      });
    });

    // --- 4. RESPONSIVE AUTO-CLOSE ---
    // This listener runs every time the window is resized
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 992 && portal.classList.contains('is-active')) {
        closePortal();
      }
    });
  });

  // Global click-outside listener
  document.addEventListener('click', (e) => {
    const activePortal = document.querySelector('[data-portal-content].is-active');
    if (activePortal && !activePortal.querySelector('.mobile-drag-content').contains(e.target) && !e.target.closest('[data-portal-trigger]')) {
      activePortal.querySelector('[data-portal-close]')?.click();
    }
  });
};

runWhenIdle(initFeatureBannerPortal);
document.addEventListener('shopify:section:load', initFeatureBannerPortal);



const initTabsPillTracker = () => {
  const container = document.querySelector('.tabs-nav-list');
  const tracker = container?.querySelector('.nav-pill-tracker');
  const items = container?.querySelectorAll('.tabs-nav-button');

  if (!container || !tracker || !items.length) return;

  const movePill = (element) => {
    const { offsetLeft, offsetWidth } = element;
    
    tracker.style.width = `${offsetWidth}px`;
    tracker.style.transform = `translateX(${offsetLeft}px)`;
    // tracker.style.opacity = '1';
  };

  // Only used for initialization and window resizing
  const syncPillToActive = () => {
    const activeItem = container.querySelector('.tabs-nav-item.is-active');
    if (activeItem) {
      movePill(activeItem);
    }
  };

  items.forEach(item => {
    // Moves to the item on hover
    item.addEventListener('mouseenter', () => movePill(item));
    
    // Updates the 'is-active' state and snaps pill on click
    item.addEventListener('click', () => {
      items.forEach(i => i.classList.remove('is-active'));
      item.classList.add('is-active');
      movePill(item);
    });
  });

  /* Removed: container.addEventListener('mouseleave', resetPill);
     By removing this, the pill stays exactly where it was last seen.
  */

  // Still necessary: Recalculate if the screen size changes so the pill doesn't drift
  window.addEventListener('resize', syncPillToActive);

  // Initial setup
  syncPillToActive();
};

runWhenIdle(initTabsPillTracker);
document.addEventListener('shopify:section:load', initTabsPillTracker);



const initStickyScrollEngine = () => {
  if (window.__themeStickyScrollState && window.__themeStickyScrollState.requestUpdate) {
    window.__themeStickyScrollState.requestUpdate();
    return;
  }

  const state = {
    ticking: false
  };

  const updateProgress = () => {
    state.ticking = false;

    const items = document.querySelectorAll('[data-sticky-item]');
    if (!items.length) return;

    const vh = window.innerHeight || document.documentElement.clientHeight || 0;

    items.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      const nextItem = items[index + 1];

      let enter = 1 - (rect.top / vh);
      enter = Math.max(0, Math.min(1, enter));
      item.style.setProperty('--scroll-enter', enter.toFixed(3));

      if (nextItem) {
        const nextRect = nextItem.getBoundingClientRect();
        let exit = 1 - (nextRect.top / vh);
        exit = Math.max(0, Math.min(1, exit));
        item.style.setProperty('--scroll-exit', exit.toFixed(3));
      } else {
        item.style.setProperty('--scroll-exit', '0');
      }
    });
  };

  state.requestUpdate = () => {
    if (state.ticking) return;
    state.ticking = true;
    requestAnimationFrame(updateProgress);
  };

  window.addEventListener('scroll', state.requestUpdate, { passive: true });
  window.addEventListener('resize', state.requestUpdate);
  document.addEventListener('shopify:section:load', state.requestUpdate);
  window.__themeStickyScrollState = state;
  state.requestUpdate();
};

runWhenIdle(initStickyScrollEngine);

const initScopedCardHover = () => {
  const desktopQuery = window.matchMedia("(min-width: 992px)");
  const groups = document.querySelectorAll('[hovered-cards-group]');

  if (!groups.length) return;

  groups.forEach(group => {
    // Find all cards strictly within this specific group
    const cards = group.querySelectorAll('[hovered-card-effect]');

    cards.forEach(card => {
      // 1. Mouse Enter: Apply States
      card.addEventListener('mouseenter', () => {
        if (!desktopQuery.matches) return;

        cards.forEach(c => {
          if (c === card) {
            c.classList.add('is-hovered');
            c.classList.remove('not-hovered');
          } else {
            c.classList.add('not-hovered');
            c.classList.remove('is-hovered');
          }
        });
      });

      // 2. Mouse Leave: Reset Group
      card.addEventListener('mouseleave', () => {
        if (!desktopQuery.matches) return;
        
        cards.forEach(c => {
          c.classList.remove('is-hovered', 'not-hovered');
        });
      });
    });
  });

  // 3. Resize Cleanup
  desktopQuery.addEventListener('change', (e) => {
    if (!e.matches) {
      document.querySelectorAll('[hovered-card-effect]').forEach(c => {
        c.classList.remove('is-hovered', 'not-hovered');
      });
    }
  });
};

// Initialize on Load
runWhenIdle(initScopedCardHover);

// Shopify Theme Editor Support
document.addEventListener('shopify:section:load', initScopedCardHover);

if (!customElements.get('card-product')) {
  customElements.define('card-product', class CardProduct extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      var swatch = event.target.closest('.color-swatch');
      if (!swatch || !this.contains(swatch)) return;

      var imageUrl = swatch.getAttribute('data-variant-image');
      if (!imageUrl) return;

      var primaryImage = this.querySelector('.card-product-img-primary');
      if (!primaryImage) return;

      primaryImage.src = imageUrl;
      primaryImage.srcset = imageUrl + ' 533w';

      var items = this.querySelectorAll('.swatches-item');
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('active');
      }

      var currentItem = swatch.closest('.swatches-item');
      if (currentItem) {
        currentItem.classList.add('active');
      }
    }
  });
}
class NewsletterForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input[name='contact[email]']");
    this.form = this.querySelector("form");
    this.message = this.querySelector(".form-message__wrapper-email");
    this.submitBtn = this.querySelector(`[type="submit"]`);
    this.pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    this.initEvents();
  }

  initEvents() {
    this.input.addEventListener(
      "input",
      function () {
        let value = this.input.value.trim();
        this.pattern.test(value)
          ? ((this.message.style.display = "none"),
            (this.submitBtn.disabled = !1))
          : ((this.message.style.display = "flex"),
            (this.submitBtn.disabled = !0));
      }.bind(this)
    );
    this.submitBtn.addEventListener(
      "submit",
      function (e) {
        let value = this.input.value.trim();
        this.pattern.test(value) ||
          (e.preventDefault(),
          (this.message.style.display = "flex"),
          (this.submitBtn.disabled = !0));
      }.bind(this)
    );
  }
}

customElements.define("newsletter-form", NewsletterForm);

customElements.define(
  'quick-order-list',
  class QuickOrderList extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      var toggle = event.target.closest('.quick-order-list-toggle');
      if (!toggle || !this.contains(toggle)) return;

      var item = toggle.closest('[data-quick-order-item]');
      if (!item) return;

      var content = item.querySelector('.quick-order-list-product-content');
      var inner = item.querySelector('[data-quick-order-content]');
      var template = item.querySelector('[data-quick-order-template]');

      if (!content || !inner) return;

      if (!inner.hasChildNodes() && template) {
        inner.appendChild(template.content.cloneNode(true));
      }

      var isOpen = item.classList.contains('is-open');

      if (isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';

        requestAnimationFrame(function () {
          content.style.maxHeight = '0px';
          content.setAttribute('inert', '');
          item.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        });

        return;
      }

      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      content.removeAttribute('inert');

      content.style.maxHeight = '0px';

      requestAnimationFrame(function () {
        content.style.maxHeight = content.scrollHeight + 'px';
      });

      content.addEventListener(
        'transitionend',
        function handler() {
          if (item.classList.contains('is-open')) {
            content.style.maxHeight = 'none';
          }

          content.removeEventListener('transitionend', handler);
        }
      );
    }
  }
);